window.MC_REVIEWS = {
  "generated": "2026-09-18T12:58:25.965Z",
  "platform": "Yotpo",
  "totals": {
    "count": 215,
    "average": 4.76
  },
  "products": {
    "4-play-mattress": {
      "count": 1,
      "average": 5
    },
    "hybrid-mattress-australia": {
      "count": 9,
      "average": 4.5555553
    },
    "boutique-craft-cell-mattress": {
      "count": 0,
      "average": 0
    },
    "boutique-deluxe-mattress": {
      "count": 31,
      "average": 4.935484
    },
    "luxury-mattress-australia-boutique": {
      "count": 42,
      "average": 4.6904764
    },
    "boutique-extra-firm-mattress": {
      "count": 10,
      "average": 4.8
    },
    "boutique-mattress-memory-foam": {
      "count": 89,
      "average": 4.741573
    },
    "grandeur": {
      "count": 13,
      "average": 4.6153846
    },
    "resort": {
      "count": 2,
      "average": 5
    },
    "retreat": {
      "count": 7,
      "average": 4.857143
    },
    "superior": {
      "count": 8,
      "average": 4.875
    },
    "chiro-luxe": {
      "count": 1,
      "average": 5
    },
    "elevate-essential-mattress": {
      "count": 1,
      "average": 5
    },
    "exquisite-premier-mattress": {
      "count": 0,
      "average": 0
    },
    "exquisite-signature-mattress": {
      "count": 1,
      "average": 5
    }
  },
  "reviews": [
    {
      "id": 888196701,
      "score": 5,
      "title": "Heaven",
      "content": "I’ve had severe back issues for quite some time. Now I know a good part of the pain was in relation to my old mattress. It’s still early days, but the 4 Play Mattress has helped dramatically. It’s so supportive and comfortable that I can’t find any fault. Delivery and unwrapping was a no-brainer. Can’t believe something so comfortable came in such a small box. Thank you for making my life so much better!",
      "created_at": "2026-09-10T00:14:59.000Z",
      "verified_buyer": true,
      "reviewer": "Leslie H.",
      "product_handle": "4-play-mattress",
      "product_title": "4 Play Mattress",
      "tags": []
    },
    {
      "id": 709872272,
      "score": 5,
      "title": "Comfortable and supportive",
      "content": "I was concerned that it wouldn’t be comfortable for me- mattresses are such an individual choice. The hybrid mattress is comfortable and supportive. Soft enough to cushion but the springs give it a firmness and a supportive stability.",
      "created_at": "2025-05-17T20:52:02.000Z",
      "verified_buyer": true,
      "reviewer": "Linda B.",
      "product_handle": "hybrid-mattress-australia",
      "product_title": "Boutique Craft Cell Hybrid Mattress",
      "tags": []
    },
    {
      "id": 333125379,
      "score": 5,
      "title": "Very happy with this mattress",
      "content": "Very happy with this mattress 👍",
      "created_at": "2022-01-30T21:25:59.000Z",
      "verified_buyer": true,
      "reviewer": "Emad Y.",
      "product_handle": "hybrid-mattress-australia",
      "product_title": "Boutique Craft Cell Hybrid Mattress",
      "tags": []
    },
    {
      "id": 617724619,
      "score": 5,
      "title": "Fantastic Mattress",
      "content": "I really wasn't sure what to expect with a hybrid mattress having always slept on a latex mattress, but Bianca was amazing with providing information and pictures to help me understand how it all worked with the inner springs. The mattress is really comfortable and provides incredible support. It's more firm than I expected but I quite like this. The pillow top is soft and cooling which is great in the warmer climates. I couldn't be happier with this purchase. Thank you team!!",
      "created_at": "2024-09-04T04:50:46.000Z",
      "verified_buyer": false,
      "reviewer": "Natalie H.",
      "product_handle": "hybrid-mattress-australia",
      "product_title": "Boutique Craft Cell Hybrid Mattress",
      "tags": [
        "hot",
        "box"
      ]
    },
    {
      "id": 314189401,
      "score": 5,
      "title": "excellent and on time !",
      "content": "excellent and on time !",
      "created_at": "2021-09-15T00:00:00.000Z",
      "verified_buyer": false,
      "reviewer": "Lindy",
      "product_handle": "hybrid-mattress-australia",
      "product_title": "Boutique Craft Cell Hybrid Mattress",
      "tags": []
    },
    {
      "id": 751423749,
      "score": 5,
      "title": "Unexpected comfort",
      "content": "We purchased these mattresses as we needed to have something compact to get into our apartment. Upon researching flat pack mattresses we came across mattress crafters which suited our budget. One of the most comfiest beds and best night sleeps i've had. Plush but firm and doesn't sink in when i'm sleeping next to my husband.",
      "created_at": "2025-08-31T06:11:36.000Z",
      "verified_buyer": true,
      "reviewer": "Helen h.",
      "product_handle": "boutique-deluxe-mattress",
      "product_title": "Boutique Deluxe Mattress",
      "tags": [
        "partner"
      ]
    },
    {
      "id": 564532876,
      "score": 5,
      "title": "Best mattress on the market.",
      "content": "Best mattress on the market for the price. Feels like a high end hotel mattress. We bought 1 for our spare bed and loved it so much we bought another for our bed.",
      "created_at": "2024-04-04T01:30:31.000Z",
      "verified_buyer": true,
      "reviewer": "Georgie L.",
      "product_handle": "boutique-deluxe-mattress",
      "product_title": "Boutique Deluxe Mattress",
      "tags": [
        "value"
      ]
    },
    {
      "id": 890876607,
      "score": 5,
      "title": "Great price and super comfy",
      "content": "Great price and super comfy",
      "created_at": "2026-09-16T02:16:56.000Z",
      "verified_buyer": true,
      "reviewer": "Peter C.",
      "product_handle": "boutique-deluxe-mattress",
      "product_title": "Boutique Deluxe Mattress",
      "tags": [
        "value"
      ]
    },
    {
      "id": 890859468,
      "score": 5,
      "title": "New Mattress",
      "content": "We are both really happy with this mattress and have been sleeping great. A nice mix of soft but firm. Would buy again",
      "created_at": "2026-09-15T22:09:52.000Z",
      "verified_buyer": true,
      "reviewer": "Damian R.",
      "product_handle": "boutique-deluxe-mattress",
      "product_title": "Boutique Deluxe Mattress",
      "tags": []
    },
    {
      "id": 884270658,
      "score": 5,
      "title": "new matress",
      "content": "great matress comfortable and exactly as advertiswd prompt delivery too",
      "created_at": "2026-08-25T04:30:41.000Z",
      "verified_buyer": true,
      "reviewer": "Mareck O.",
      "product_handle": "boutique-deluxe-mattress",
      "product_title": "Boutique Deluxe Mattress",
      "tags": []
    },
    {
      "id": 879370238,
      "score": 5,
      "title": "Not what I hoped for",
      "content": "Delivery was great. But unfortunately, not the right mattress for me\nThe mattress is not as firm as I expected, with quite a lot of springy movement and partner disturbance. I also found there was very little edge support, and the top layer wasn’t as plush or comfortable as I had hoped.\nSorry, Mattress Crafters, I really wanted to love it, but unfortunately it’s just not the right mattress for me.\nI understand that keeping costs down means not offering a collection service, but being charged $290 to return the mattress makes this a very expensive mistake.",
      "created_at": "2026-08-10T04:11:55.000Z",
      "verified_buyer": true,
      "reviewer": "Natasha B.",
      "product_handle": "boutique-deluxe-mattress",
      "product_title": "Boutique Deluxe Mattress",
      "tags": [
        "partner",
        "value"
      ]
    },
    {
      "id": 875416177,
      "score": 5,
      "title": "Love it. It’s like sleeping",
      "content": "Love it. It’s like sleeping on a cloud, very happy with my purchase. I was reluctant at first, but technology is amazing. Thank you",
      "created_at": "2026-07-29T08:27:17.000Z",
      "verified_buyer": true,
      "reviewer": "Anna M.",
      "product_handle": "boutique-deluxe-mattress",
      "product_title": "Boutique Deluxe Mattress",
      "tags": []
    },
    {
      "id": 818996447,
      "score": 5,
      "title": "Boutique Deluxe Mattress",
      "content": "It was a gift and the person who received it, is very happy.",
      "created_at": "2026-03-13T02:52:42.000Z",
      "verified_buyer": true,
      "reviewer": "Dieter D.",
      "product_handle": "boutique-deluxe-mattress",
      "product_title": "Boutique Deluxe Mattress",
      "tags": [
        "kids"
      ]
    },
    {
      "id": 806724629,
      "score": 5,
      "title": "A little skepticism now dismissed",
      "content": "I had been researching new mattresses online for some time and was surprised to find a quality mattress at such a good price. It arrived boxed and when unpacked quickly expanded to size. We have different comfort level needs and this mattress is fantastic. I love climbing into bed now and have found it so superior to the previous mattress (much more expensive) we had. So comfortable and I’m glad I took the chance on it",
      "created_at": "2026-02-08T16:45:17.000Z",
      "verified_buyer": true,
      "reviewer": "Nichole M.",
      "product_handle": "boutique-deluxe-mattress",
      "product_title": "Boutique Deluxe Mattress",
      "tags": [
        "box",
        "value"
      ]
    },
    {
      "id": 788157555,
      "score": 5,
      "title": "Mattress",
      "content": "I just love this mattress. . Its very comfy.",
      "created_at": "2025-12-07T23:39:06.000Z",
      "verified_buyer": true,
      "reviewer": "Upama A.",
      "product_handle": "boutique-deluxe-mattress",
      "product_title": "Boutique Deluxe Mattress",
      "tags": []
    },
    {
      "id": 773105022,
      "score": 5,
      "title": "Impressive",
      "content": "It’s only been a week, but I am very impressed with this mattress so far. It’s extremely comfortable, feels soft but is firm at the same time. Wasn’t sure about the level of firmness, last mattress was a few thousand dollars and much firmer but nowhere near as comfortable. Would buy again.",
      "created_at": "2025-10-22T11:15:41.000Z",
      "verified_buyer": true,
      "reviewer": "Naomi P.",
      "product_handle": "boutique-deluxe-mattress",
      "product_title": "Boutique Deluxe Mattress",
      "tags": []
    },
    {
      "id": 772222507,
      "score": 5,
      "title": "Boutique deluxe",
      "content": "I was nervous purchasing a mattress online but after lots of research and considering my budget I’m so happy I brought this. I followed the instructions and allowed 48 hours for it to be ready to sleep on. I suffer from chronic back pain so was anxious about how my sleep would go. I’m absolutely delighted to say that this mattress has exceeded all my expectations. I’ve only had it for 3 weeks but definitely happy so far. Would definitely buy off a local company again. Thankyou. ☺️",
      "created_at": "2025-10-21T03:07:15.000Z",
      "verified_buyer": true,
      "reviewer": "Donna J.",
      "product_handle": "boutique-deluxe-mattress",
      "product_title": "Boutique Deluxe Mattress",
      "tags": [
        "back"
      ]
    },
    {
      "id": 756534815,
      "score": 5,
      "title": "Sleepy",
      "content": "Mattresses were delivered quickly. They have been used and have allowed me to sleep comfortably throughout the night. Would recommend this mattress from Mattress Crafters!",
      "created_at": "2025-09-10T03:23:23.000Z",
      "verified_buyer": true,
      "reviewer": "Keith L.",
      "product_handle": "boutique-deluxe-mattress",
      "product_title": "Boutique Deluxe Mattress",
      "tags": []
    },
    {
      "id": 727513040,
      "score": 5,
      "title": "2 new Queen Boutique Deluxe mattresses",
      "content": "Purchased 2 new queen mattresses and before we knew it they were delivered. We’ve moved home unboxed waited the recommended time then made them up and spent our first night in our new home on the most comfortable mattress such a great experience all round 👍👏\nThe only - was very heavy and hard to lift but once done all good.",
      "created_at": "2025-07-11T12:48:18.000Z",
      "verified_buyer": true,
      "reviewer": "Jeanette M.",
      "product_handle": "boutique-deluxe-mattress",
      "product_title": "Boutique Deluxe Mattress",
      "tags": [
        "box"
      ]
    },
    {
      "id": 669565170,
      "score": 5,
      "title": "Excellent quality and value",
      "content": "So luxurious yet supportive. Amazing value. Highly recommended!",
      "created_at": "2025-01-16T01:56:24.000Z",
      "verified_buyer": true,
      "reviewer": "Andrew S.",
      "product_handle": "boutique-deluxe-mattress",
      "product_title": "Boutique Deluxe Mattress",
      "tags": []
    },
    {
      "id": 656094340,
      "score": 5,
      "title": "Supportive and comfortable",
      "content": "Very comfortable, has eased my lower back pain considerably. Definitely worth it! Arrived quickly, very easy to set up.",
      "created_at": "2024-12-03T11:46:54.000Z",
      "verified_buyer": true,
      "reviewer": "Angela G.",
      "product_handle": "boutique-deluxe-mattress",
      "product_title": "Boutique Deluxe Mattress",
      "tags": [
        "back",
        "value"
      ]
    },
    {
      "id": 747630109,
      "score": 5,
      "title": "Very comfortable",
      "content": "I have to say that my boutique deluxe is the most comfortable mattress I have ever slept on. It's alleviated so much pain in my body. With the zoned supports I feel like my spine is better aligned, and I prefer hybrid mattresses so this is great. I ordered it quite late one night and it still arrived the next day! I think I paid $700 for it, which considering the quality is very cheap. I prefer a medium plush feel so I've added a topper for extra cosiness but that's just a personal choice, there's no real need for it.",
      "created_at": "2025-08-25T00:41:53.000Z",
      "verified_buyer": false,
      "reviewer": "Kate W.",
      "product_handle": "boutique-deluxe-mattress",
      "product_title": "Boutique Deluxe Mattress",
      "tags": [
        "back",
        "kids",
        "value"
      ]
    },
    {
      "id": 677903127,
      "score": 5,
      "title": "Impressed",
      "content": "After a small initial glitch with processing the order (quickly resolved) the two mattresses we ordered arrived in the promised time. Very impressed with them, so much so will probably order another one!",
      "created_at": "2025-02-09T04:04:53.000Z",
      "verified_buyer": false,
      "reviewer": "John B.",
      "product_handle": "boutique-deluxe-mattress",
      "product_title": "Boutique Deluxe Mattress",
      "tags": []
    },
    {
      "id": 328735521,
      "score": 5,
      "title": "Fast delivery and loving my",
      "content": "Fast delivery and loving my mattress!",
      "created_at": "2022-01-13T00:00:00.000Z",
      "verified_buyer": false,
      "reviewer": "Jenny",
      "product_handle": "boutique-deluxe-mattress",
      "product_title": "Boutique Deluxe Mattress",
      "tags": []
    },
    {
      "id": 328522575,
      "score": 5,
      "title": "The matress was packed well",
      "content": "The matress was packed well and delivered in the timeframe given. it is a very comfortable mattress and well worth the price. Thank you",
      "created_at": "2022-01-12T00:00:00.000Z",
      "verified_buyer": false,
      "reviewer": "Winn",
      "product_handle": "boutique-deluxe-mattress",
      "product_title": "Boutique Deluxe Mattress",
      "tags": [
        "value"
      ]
    },
    {
      "id": 328518620,
      "score": 5,
      "title": "Love the new mattress extremely",
      "content": "Love the new mattress extremely comfortable",
      "created_at": "2022-01-12T00:00:00.000Z",
      "verified_buyer": false,
      "reviewer": "Sue",
      "product_handle": "boutique-deluxe-mattress",
      "product_title": "Boutique Deluxe Mattress",
      "tags": []
    },
    {
      "id": 288592317,
      "score": 5,
      "title": "Thank you ...",
      "content": "Thank you ...",
      "created_at": "2021-08-04T00:00:00.000Z",
      "verified_buyer": false,
      "reviewer": "mbcscp_2001",
      "product_handle": "boutique-deluxe-mattress",
      "product_title": "Boutique Deluxe Mattress",
      "tags": []
    },
    {
      "id": 288592324,
      "score": 5,
      "title": "I am very happy They",
      "content": "I am very happy They did everything i asked for I had special requests",
      "created_at": "2021-06-22T00:00:00.000Z",
      "verified_buyer": false,
      "reviewer": "kerbyf_0",
      "product_handle": "boutique-deluxe-mattress",
      "product_title": "Boutique Deluxe Mattress",
      "tags": []
    },
    {
      "id": 288592326,
      "score": 5,
      "title": "I certainly recommend this mattress",
      "content": "I certainly recommend this mattress for value for money. Fast delivery and very comfortable with good quality. Great seller highly recommended",
      "created_at": "2021-06-17T00:00:00.000Z",
      "verified_buyer": false,
      "reviewer": "v8boss",
      "product_handle": "boutique-deluxe-mattress",
      "product_title": "Boutique Deluxe Mattress",
      "tags": [
        "value"
      ]
    },
    {
      "id": 288592322,
      "score": 5,
      "title": "Quick dispatch and kept in",
      "content": "Quick dispatch and kept in touch. Thanks",
      "created_at": "2021-06-07T00:00:00.000Z",
      "verified_buyer": false,
      "reviewer": "craggles92",
      "product_handle": "boutique-deluxe-mattress",
      "product_title": "Boutique Deluxe Mattress",
      "tags": []
    },
    {
      "id": 288592325,
      "score": 5,
      "title": "Fantastic mattress in a box,",
      "content": "Fantastic mattress in a box, extremely comfortable",
      "created_at": "2021-06-06T00:00:00.000Z",
      "verified_buyer": false,
      "reviewer": "*boppie*",
      "product_handle": "boutique-deluxe-mattress",
      "product_title": "Boutique Deluxe Mattress",
      "tags": [
        "box"
      ]
    },
    {
      "id": 288592329,
      "score": 5,
      "title": "Fast delivery & great product.",
      "content": "Fast delivery & great product. Thanks so much.",
      "created_at": "2021-05-06T00:00:00.000Z",
      "verified_buyer": false,
      "reviewer": "sr073",
      "product_handle": "boutique-deluxe-mattress",
      "product_title": "Boutique Deluxe Mattress",
      "tags": []
    },
    {
      "id": 288592334,
      "score": 5,
      "title": "Very happy with purchase and",
      "content": "Very happy with purchase and super fast delivery",
      "created_at": "2021-05-05T00:00:00.000Z",
      "verified_buyer": false,
      "reviewer": "eathan6",
      "product_handle": "boutique-deluxe-mattress",
      "product_title": "Boutique Deluxe Mattress",
      "tags": []
    },
    {
      "id": 288592333,
      "score": 5,
      "title": "Thank you super fast delivery",
      "content": "Thank you super fast delivery and amazing quality mattress. So comfy",
      "created_at": "2021-03-25T00:00:00.000Z",
      "verified_buyer": false,
      "reviewer": "kezdixon14",
      "product_handle": "boutique-deluxe-mattress",
      "product_title": "Boutique Deluxe Mattress",
      "tags": []
    },
    {
      "id": 288592318,
      "score": 5,
      "title": "Very comfy mattress.",
      "content": "Very comfy mattress.",
      "created_at": "2021-03-18T00:00:00.000Z",
      "verified_buyer": false,
      "reviewer": "princess*moo",
      "product_handle": "boutique-deluxe-mattress",
      "product_title": "Boutique Deluxe Mattress",
      "tags": []
    },
    {
      "id": 885484979,
      "score": 3,
      "title": "Too firm for me",
      "content": "This mattress is much firmer than I expected. We have needed to buy a memory foam topper as the return postage cost was half the price of the mattress and not worth it",
      "created_at": "2026-08-31T00:22:35.000Z",
      "verified_buyer": true,
      "reviewer": "Katrina C.",
      "product_handle": "boutique-deluxe-mattress",
      "product_title": "Boutique Deluxe Mattress",
      "tags": [
        "value"
      ]
    },
    {
      "id": 729375747,
      "score": 5,
      "title": "So happy with this new mattress.",
      "content": "Mattress is a great new addition to our guest room. So comfortable, and yep I’ve tried it out.",
      "created_at": "2025-07-17T06:04:16.000Z",
      "verified_buyer": true,
      "reviewer": "Shane C.",
      "product_handle": "luxury-mattress-australia-boutique",
      "product_title": "Boutique Deluxe Plus Mattress",
      "tags": [
        "kids"
      ]
    },
    {
      "id": 774915995,
      "score": 4,
      "title": "Love the mattress",
      "content": "I love the mattress, very comfortable, but was disappointed by the delivery. I was told that the mattress would arrive on Tuesday, but it arrived on Saturday and was left next to a down-pipe in the rain, when there is an undercover area five meters away.",
      "created_at": "2025-10-29T23:27:22.000Z",
      "verified_buyer": true,
      "reviewer": "Anita O.",
      "product_handle": "luxury-mattress-australia-boutique",
      "product_title": "Boutique Deluxe Plus Mattress",
      "tags": []
    },
    {
      "id": 877082282,
      "score": 5,
      "title": "Very happy 😊",
      "content": "Very happy 😊",
      "created_at": "2026-08-04T23:55:55.000Z",
      "verified_buyer": true,
      "reviewer": "Amanda B.",
      "product_handle": "luxury-mattress-australia-boutique",
      "product_title": "Boutique Deluxe Plus Mattress",
      "tags": []
    },
    {
      "id": 871789203,
      "score": 5,
      "title": "Really happy with quality and",
      "content": "Really happy with quality and service arrived on time, and very comfortable.",
      "created_at": "2026-07-20T04:00:29.000Z",
      "verified_buyer": true,
      "reviewer": "wayne c.",
      "product_handle": "luxury-mattress-australia-boutique",
      "product_title": "Boutique Deluxe Plus Mattress",
      "tags": []
    },
    {
      "id": 868592818,
      "score": 5,
      "title": "Extremely comfortable",
      "content": "Super quick delivery exceptional comfort very happy 😁",
      "created_at": "2026-07-13T05:31:09.000Z",
      "verified_buyer": true,
      "reviewer": "Jayne L.",
      "product_handle": "luxury-mattress-australia-boutique",
      "product_title": "Boutique Deluxe Plus Mattress",
      "tags": []
    },
    {
      "id": 834206755,
      "score": 5,
      "title": "Excellent quality, quick postage and great value!",
      "content": "We chose Mattress Crafters after looking around online a lot. Combined with their story and many positive reviews, we are happy to say the quality and service are up to expectations.\nOnly time will tell if the mattress holds up long term, but at this stage we will most likely be buying another one soon!",
      "created_at": "2026-04-27T06:27:39.000Z",
      "verified_buyer": true,
      "reviewer": "Torsten T.",
      "product_handle": "luxury-mattress-australia-boutique",
      "product_title": "Boutique Deluxe Plus Mattress",
      "tags": []
    },
    {
      "id": 772089309,
      "score": 5,
      "title": "Great mattress at a great price",
      "content": "I'd bought one before from these guys for our spare room. This time we wanted one for ourselves and decided to upgrade a little for a more plush top. Great decision. Its firm but gives nicely for the shoulders and hips. 2 side sleepers and it works for us. Very impressed.",
      "created_at": "2025-10-20T04:07:02.000Z",
      "verified_buyer": true,
      "reviewer": "Darren W.",
      "product_handle": "luxury-mattress-australia-boutique",
      "product_title": "Boutique Deluxe Plus Mattress",
      "tags": [
        "hips",
        "kids",
        "value"
      ]
    },
    {
      "id": 767631769,
      "score": 5,
      "title": "Best mattress ever",
      "content": "Seriously has moved my wife and I back into the same bed. It's so comfy and the extra room being a king is a added bonus!",
      "created_at": "2025-10-07T05:12:06.000Z",
      "verified_buyer": true,
      "reviewer": "Luke M.",
      "product_handle": "luxury-mattress-australia-boutique",
      "product_title": "Boutique Deluxe Plus Mattress",
      "tags": [
        "partner"
      ]
    },
    {
      "id": 758326493,
      "score": 5,
      "title": "Great nights sleep",
      "content": "Speedy delivery and a great mattress",
      "created_at": "2025-09-16T11:47:12.000Z",
      "verified_buyer": true,
      "reviewer": "Gavin P.",
      "product_handle": "luxury-mattress-australia-boutique",
      "product_title": "Boutique Deluxe Plus Mattress",
      "tags": []
    },
    {
      "id": 735193855,
      "score": 5,
      "title": "Lovely and comfy",
      "content": "I've really been enjoying the zoned springs in this bed. I feel comfortable and properly supported and like my spine is more aligned. The top of the mattress wasn't quite plush enough for me, I enjoy a bit of a marshmallow bed, so I added a topper and now it's perfect and still feels properly supportive. I've had a bad back and neck from using a foam bed that was way too firm so this bed has really been a treat. It arrived next day as promised even though I ordered it quite late at night because I couldn't stand my foam mattress anymore and was so excited to get my new mattress!",
      "created_at": "2025-08-06T13:20:14.000Z",
      "verified_buyer": true,
      "reviewer": "Kate",
      "product_handle": "luxury-mattress-australia-boutique",
      "product_title": "Boutique Deluxe Plus Mattress",
      "tags": [
        "back",
        "box"
      ]
    },
    {
      "id": 716915870,
      "score": 5,
      "title": "Very comfortable",
      "content": "Really please with the purchase, comfortable to sleep in. Would highly recommend",
      "created_at": "2025-06-11T00:09:39.000Z",
      "verified_buyer": true,
      "reviewer": "Aaron K.",
      "product_handle": "luxury-mattress-australia-boutique",
      "product_title": "Boutique Deluxe Plus Mattress",
      "tags": []
    },
    {
      "id": 708540696,
      "score": 5,
      "title": "Overall a good balance of medium firm with plush",
      "content": "Its a great mattress, it was firmer than I expected but my sleep has been fine and I purchased from Mattress Crafters because reviewers were positive about the durability of their products. I think it's incredible value for money now that I have tried it out for a week. I have scoliosis and wanted a plush upper surface for my back to sink into, I was not suited to the typical medium firm mattresses out there. . Overall a good balance of medium firm with plush. I suspect my body will benefit from the support given by the pocket springs.",
      "created_at": "2025-05-12T09:41:25.000Z",
      "verified_buyer": true,
      "reviewer": "Dean M.",
      "product_handle": "luxury-mattress-australia-boutique",
      "product_title": "Boutique Deluxe Plus Mattress",
      "tags": [
        "value"
      ]
    },
    {
      "id": 685082424,
      "score": 5,
      "title": "Ordering and delivery for simple",
      "content": "Ordering and delivery for simple and quick. \nThe mattress is super comfy. Very happy",
      "created_at": "2025-03-03T00:02:28.000Z",
      "verified_buyer": true,
      "reviewer": "Marc E.",
      "product_handle": "luxury-mattress-australia-boutique",
      "product_title": "Boutique Deluxe Plus Mattress",
      "tags": []
    },
    {
      "id": 651193617,
      "score": 5,
      "title": "Great value",
      "content": "I ordered the adjustable bed frame and this mattress was said to be compatible. It is very luxurious, so far so good.",
      "created_at": "2024-11-14T22:29:15.000Z",
      "verified_buyer": true,
      "reviewer": "Belinda O.",
      "product_handle": "luxury-mattress-australia-boutique",
      "product_title": "Boutique Deluxe Plus Mattress",
      "tags": []
    },
    {
      "id": 643389769,
      "score": 5,
      "title": "Fantastic purchase",
      "content": "I am loving this new mattress - nice and firm, but really cozy too.",
      "created_at": "2024-10-28T12:13:55.000Z",
      "verified_buyer": true,
      "reviewer": "Rebecca K.",
      "product_handle": "luxury-mattress-australia-boutique",
      "product_title": "Boutique Deluxe Plus Mattress",
      "tags": []
    },
    {
      "id": 628043964,
      "score": 5,
      "title": "Amazing",
      "content": "Extremely prompt delivery and such a comfortable mattress. Already looking to purchase our next mattress through Mattress Crafters",
      "created_at": "2024-09-22T00:15:44.000Z",
      "verified_buyer": true,
      "reviewer": "Stuart T.",
      "product_handle": "luxury-mattress-australia-boutique",
      "product_title": "Boutique Deluxe Plus Mattress",
      "tags": []
    },
    {
      "id": 499259910,
      "score": 5,
      "title": "Totally worth every cent!",
      "content": "I was sceptical to start with but that was quickly put to bed so to speak. Delivery was fast, my mattress arrived within 5 days. Unwrapping was... explosively hilarious. I'm not sure we did it right, but if you're like us, I recommend you remove any valuable items from the immediate area and keep your head and arms out of the way. After the fun of unwrapping my first night sleeping on it was magic! The zones are comfortable and it didn't sink at all so I didn't feel overly hot and slept well. I woke up rested and without the usual aches and pains.",
      "created_at": "2023-09-10T01:55:41.000Z",
      "verified_buyer": true,
      "reviewer": "Kelly B.",
      "product_handle": "luxury-mattress-australia-boutique",
      "product_title": "Boutique Deluxe Plus Mattress",
      "tags": [
        "box"
      ]
    },
    {
      "id": 455665887,
      "score": 5,
      "title": "Comfort",
      "content": "This mattress is as advertised",
      "created_at": "2023-03-27T05:02:28.000Z",
      "verified_buyer": true,
      "reviewer": "Catherine M.",
      "product_handle": "luxury-mattress-australia-boutique",
      "product_title": "Boutique Deluxe Plus Mattress",
      "tags": []
    },
    {
      "id": 380897067,
      "score": 5,
      "title": "Very good all round",
      "content": "Purchased Excellence Mattress for my daughetr. Arrived in great time and a very comfortable mattress. Looking forward to purchasing the next one for myslef!",
      "created_at": "2022-06-24T07:31:09.000Z",
      "verified_buyer": true,
      "reviewer": "Paul G.",
      "product_handle": "luxury-mattress-australia-boutique",
      "product_title": "Boutique Deluxe Plus Mattress",
      "tags": []
    },
    {
      "id": 359335404,
      "score": 5,
      "title": "Quick Delivery",
      "content": "Quick Delivery and great mattress",
      "created_at": "2022-04-22T15:35:32.000Z",
      "verified_buyer": true,
      "reviewer": "Darlene R.",
      "product_handle": "luxury-mattress-australia-boutique",
      "product_title": "Boutique Deluxe Plus Mattress",
      "tags": []
    },
    {
      "id": 358492582,
      "score": 5,
      "title": "wonderfully comfortable. My adult daughter",
      "content": "wonderfully comfortable. My adult daughter wakes refreshed every morning",
      "created_at": "2022-04-20T01:23:57.000Z",
      "verified_buyer": true,
      "reviewer": "KJ B.",
      "product_handle": "luxury-mattress-australia-boutique",
      "product_title": "Boutique Deluxe Plus Mattress",
      "tags": [
        "kids"
      ]
    },
    {
      "id": 343615795,
      "score": 5,
      "title": "Great mattress",
      "content": "Mattress out performs the very VERY expensive mattress that preceded it, such a relief for my bad back. I would buy again and recommend without hesitation",
      "created_at": "2022-03-03T00:27:24.000Z",
      "verified_buyer": true,
      "reviewer": "Alix R.",
      "product_handle": "luxury-mattress-australia-boutique",
      "product_title": "Boutique Deluxe Plus Mattress",
      "tags": [
        "back"
      ]
    },
    {
      "id": 549423985,
      "score": 5,
      "title": "Highly recommended - Excellent quality",
      "content": "Highly recommend a Mattress Crafters mattress. The transaction from purchase to delivery was excellent. The mattress itself is superior and quality is better than others we considered. Comfort is better than others I've had in the past. Thanks Mattress Crafters, will shop with you again.",
      "created_at": "2024-02-24T02:39:30.000Z",
      "verified_buyer": false,
      "reviewer": "Mandy",
      "product_handle": "luxury-mattress-australia-boutique",
      "product_title": "Boutique Deluxe Plus Mattress",
      "tags": []
    },
    {
      "id": 549423837,
      "score": 5,
      "title": "Happy purchaser from WA",
      "content": "Folllowing on from my review 2 years ago, This mattress has maintained its original condition and is still one of the most comfortable mattresses I have owned. Excellent value than others on the market, and any hesitation at the time has long gone and I would certainly purchase another one. All round experience was wonderful from start to finish.",
      "created_at": "2024-02-24T02:35:57.000Z",
      "verified_buyer": false,
      "reviewer": "Steve P.",
      "product_handle": "luxury-mattress-australia-boutique",
      "product_title": "Boutique Deluxe Plus Mattress",
      "tags": []
    },
    {
      "id": 498912378,
      "score": 5,
      "title": "Happy Customer",
      "content": "Very pleased with my new mattress, was very different from my old mattress, so took awhile to get use to it but has been a month now and it's great, firm with great support, and a lovely soft top which doesn't feel hot or too fluffy, a really well crafted mattress with a great price and super fast delivery.",
      "created_at": "2023-09-08T00:23:26.000Z",
      "verified_buyer": false,
      "reviewer": "Shelley",
      "product_handle": "luxury-mattress-australia-boutique",
      "product_title": "Boutique Deluxe Plus Mattress",
      "tags": [
        "value"
      ]
    },
    {
      "id": 721566106,
      "score": 5,
      "title": "Excellent product and service",
      "content": "This is the second mattress that we have bought from this company.\nBoth were delivered within two days!\nVery happy with the quality and comfort of both of them.",
      "created_at": "2025-06-26T21:36:29.000Z",
      "verified_buyer": false,
      "reviewer": "Paul A.",
      "product_handle": "luxury-mattress-australia-boutique",
      "product_title": "Boutique Deluxe Plus Mattress",
      "tags": []
    },
    {
      "id": 676323461,
      "score": 5,
      "title": "Boutique Deluxe Plus Single",
      "content": "Love my new mattress. I don’t know why some say it’s too firm for them cause it’s far from being firm. I find it very comfortable and perfect for me.",
      "created_at": "2025-02-04T16:29:50.000Z",
      "verified_buyer": false,
      "reviewer": "Doreen J.",
      "product_handle": "luxury-mattress-australia-boutique",
      "product_title": "Boutique Deluxe Plus Mattress",
      "tags": []
    },
    {
      "id": 336123052,
      "score": 5,
      "title": "Nice and comfy.if u need",
      "content": "Nice and comfy.if u need new mattresses don�t think too much",
      "created_at": "2022-02-04T00:00:00.000Z",
      "verified_buyer": false,
      "reviewer": "Emre",
      "product_handle": "luxury-mattress-australia-boutique",
      "product_title": "Boutique Deluxe Plus Mattress",
      "tags": []
    },
    {
      "id": 310592592,
      "score": 5,
      "title": "Good product.",
      "content": "Good product.",
      "created_at": "2021-11-11T00:00:00.000Z",
      "verified_buyer": false,
      "reviewer": "fishing2910",
      "product_handle": "luxury-mattress-australia-boutique",
      "product_title": "Boutique Deluxe Plus Mattress",
      "tags": []
    },
    {
      "id": 288492898,
      "score": 5,
      "title": "Thank you,very happy.Delivered in record",
      "content": "Thank you,very happy.Delivered in record time (3 days) remote coastal village ??",
      "created_at": "2021-08-26T00:00:00.000Z",
      "verified_buyer": false,
      "reviewer": "tania_tomakin",
      "product_handle": "luxury-mattress-australia-boutique",
      "product_title": "Boutique Deluxe Plus Mattress",
      "tags": []
    },
    {
      "id": 288492899,
      "score": 5,
      "title": "Super fast delivery. Quality product.",
      "content": "Super fast delivery. Quality product. Very happy. Thank you",
      "created_at": "2021-08-25T00:00:00.000Z",
      "verified_buyer": false,
      "reviewer": "rodnas1957",
      "product_handle": "luxury-mattress-australia-boutique",
      "product_title": "Boutique Deluxe Plus Mattress",
      "tags": []
    },
    {
      "id": 288592319,
      "score": 5,
      "title": "Looks like good quality for",
      "content": "Looks like good quality for the money hopefully it will be very comfortable and quick delivery thanks.",
      "created_at": "2021-07-25T00:00:00.000Z",
      "verified_buyer": false,
      "reviewer": "schroombrood",
      "product_handle": "luxury-mattress-australia-boutique",
      "product_title": "Boutique Deluxe Plus Mattress",
      "tags": [
        "value"
      ]
    },
    {
      "id": 288592316,
      "score": 5,
      "title": "fabulous - comfy and quality",
      "content": "fabulous - comfy and quality mattress.Service excellent!",
      "created_at": "2021-04-13T00:00:00.000Z",
      "verified_buyer": false,
      "reviewer": "sweetsweet183",
      "product_handle": "luxury-mattress-australia-boutique",
      "product_title": "Boutique Deluxe Plus Mattress",
      "tags": []
    },
    {
      "id": 288592330,
      "score": 5,
      "title": "Comfortable mattress as described",
      "content": "Comfortable mattress as described",
      "created_at": "2021-03-28T00:00:00.000Z",
      "verified_buyer": false,
      "reviewer": "dho91",
      "product_handle": "luxury-mattress-australia-boutique",
      "product_title": "Boutique Deluxe Plus Mattress",
      "tags": []
    },
    {
      "id": 288592321,
      "score": 5,
      "title": "Fast shipping, best sleep I",
      "content": "Fast shipping, best sleep I have had in a long time.",
      "created_at": "2021-03-21T00:00:00.000Z",
      "verified_buyer": false,
      "reviewer": "tswin86",
      "product_handle": "luxury-mattress-australia-boutique",
      "product_title": "Boutique Deluxe Plus Mattress",
      "tags": []
    },
    {
      "id": 794822274,
      "score": 4,
      "title": "Very Good",
      "content": "Very happy with purchase but found that I needed a mattress topper to soften it a little, loving it now",
      "created_at": "2025-12-29T21:08:57.000Z",
      "verified_buyer": true,
      "reviewer": "Mark C.",
      "product_handle": "luxury-mattress-australia-boutique",
      "product_title": "Boutique Deluxe Plus Mattress",
      "tags": []
    },
    {
      "id": 770217770,
      "score": 4,
      "title": "Easy to set up and appears to be sound purchase",
      "content": "WE purchased 2 Boutique Deluxe Plus Matresses king single for our spare room. Grandchildren have slept on it and reckon they are very comfortable. The proof will be when aduklts sleep on them that said they appear to be a quality product for the price",
      "created_at": "2025-10-12T09:27:19.000Z",
      "verified_buyer": true,
      "reviewer": "Gerard N.",
      "product_handle": "luxury-mattress-australia-boutique",
      "product_title": "Boutique Deluxe Plus Mattress",
      "tags": [
        "kids",
        "value"
      ]
    },
    {
      "id": 355250382,
      "score": 4,
      "title": "Excellent delivery time to WA within a week of ordering👍",
      "content": "A well priced, fast delivery, comfortable king mattress.\n With no gimmicks. Would recommend to purchase.",
      "created_at": "2022-04-09T06:39:14.000Z",
      "verified_buyer": true,
      "reviewer": "Steve P.",
      "product_handle": "luxury-mattress-australia-boutique",
      "product_title": "Boutique Deluxe Plus Mattress",
      "tags": [
        "value"
      ]
    },
    {
      "id": 605213899,
      "score": 4,
      "title": "Money well spent",
      "content": "Apart from visiting a number of mattress outlets, my wife and I did a lot of investigation on the web and read a number of reviews. Ultimately, we found Mattress Crafters. Although sceptical at first on buying a mattress on-line, we decided to purchase and received the single mattress the day after ordering. It was easy to unpack and after a week of letting the mattress air-out, we have started using it for when family and friends visit. Our Boutique Deluxe Plus mattress is firm, very comfortable and suitable for our purpose.",
      "created_at": "2024-07-30T05:12:49.000Z",
      "verified_buyer": false,
      "reviewer": "Allan M.",
      "product_handle": "luxury-mattress-australia-boutique",
      "product_title": "Boutique Deluxe Plus Mattress",
      "tags": [
        "hips",
        "partner",
        "box",
        "value"
      ]
    },
    {
      "id": 885484894,
      "score": 3,
      "title": "Not as plush as expected",
      "content": "I believe this is a quality mattress but I would not include the word plush in its description. I would call this mattress a medium mattress with a lot of support. There is a small layer of soft fabric on top - but it is not plush.",
      "created_at": "2026-08-31T00:21:21.000Z",
      "verified_buyer": true,
      "reviewer": "Katrina C.",
      "product_handle": "luxury-mattress-australia-boutique",
      "product_title": "Boutique Deluxe Plus Mattress",
      "tags": []
    },
    {
      "id": 827790367,
      "score": 3,
      "title": "Boutique Delux Kingsize",
      "content": "Extremely happy with our purchase 😊\nSo easy to order online.\nFast delivery and so easy to unpack and put on the bed base followed the instructions as per packing and used unpackaging tool in box.\nHusbands first night sleep was backpain free so he is a happy Chappy now. Mattress is very comfortable I have no complaints. Mattress looks great as well.\nHighly recommend this mattress 😊😊😊😊",
      "created_at": "2026-04-07T02:08:06.000Z",
      "verified_buyer": true,
      "reviewer": "Lynne M.",
      "product_handle": "luxury-mattress-australia-boutique",
      "product_title": "Boutique Deluxe Plus Mattress",
      "tags": [
        "partner"
      ]
    },
    {
      "id": 872220582,
      "score": 1,
      "title": "Comfy for 3 weeks, now body impressions starting to show",
      "content": "The mattress was fine for 3 weeks or so but has already started to retain body impressions. It has not held up to claims that due to pocket spring design, the bed returns to normal after each night. I find myself on a slope every night now and will look to replace it.",
      "created_at": "2026-07-22T00:14:42.000Z",
      "verified_buyer": true,
      "reviewer": "Andrew P.",
      "product_handle": "luxury-mattress-australia-boutique",
      "product_title": "Boutique Deluxe Plus Mattress",
      "tags": []
    },
    {
      "id": 882058199,
      "score": 5,
      "title": "It’s a firm mattress as advertised",
      "content": "It’s a firm mattress as advertised,very heavy and strong built.",
      "created_at": "2026-08-17T11:16:33.000Z",
      "verified_buyer": true,
      "reviewer": "sunil B.",
      "product_handle": "boutique-extra-firm-mattress",
      "product_title": "Boutique Extra Firm Mattress",
      "tags": []
    },
    {
      "id": 876620084,
      "score": 5,
      "title": "Extra firm mattress",
      "content": "Queen mattress little smaller then my old queen leaving space down each side of bed frame. \nFirmness is 7/10 very springy feeling and when sitting on side of bed it dips \nWas really hoping it to be as firm as stated.",
      "created_at": "2026-08-03T00:46:38.000Z",
      "verified_buyer": true,
      "reviewer": "Amy G.",
      "product_handle": "boutique-extra-firm-mattress",
      "product_title": "Boutique Extra Firm Mattress",
      "tags": []
    },
    {
      "id": 834218138,
      "score": 5,
      "title": "⭐️⭐️⭐️⭐️⭐️",
      "content": "⭐️⭐️⭐️⭐️⭐️",
      "created_at": "2026-04-27T08:14:31.000Z",
      "verified_buyer": true,
      "reviewer": "Diana M.",
      "product_handle": "boutique-extra-firm-mattress",
      "product_title": "Boutique Extra Firm Mattress",
      "tags": []
    },
    {
      "id": 425709376,
      "score": 5,
      "title": "Strong recommended!",
      "content": "We are so happy we made the choice to buy this mattress. Very firm as we excepted. Excellent quality. Super fast delivery. Five star for everything!",
      "created_at": "2022-12-16T14:04:11.000Z",
      "verified_buyer": true,
      "reviewer": "Xiao Z.",
      "product_handle": "boutique-extra-firm-mattress",
      "product_title": "Boutique Extra Firm Mattress",
      "tags": []
    },
    {
      "id": 400058363,
      "score": 5,
      "title": "Excellent",
      "content": "This the best mattress we've had so far. We needed mattress that would not dip and so far no signs of dipping. Very pleased!!",
      "created_at": "2022-09-07T07:20:53.000Z",
      "verified_buyer": true,
      "reviewer": "Anna C.",
      "product_handle": "boutique-extra-firm-mattress",
      "product_title": "Boutique Extra Firm Mattress",
      "tags": []
    },
    {
      "id": 711655849,
      "score": 5,
      "title": "Amazing quality and firmness",
      "content": "The quality is impressive! I had a 3 thousand dollars mattress for 6 months and was horrible so I decided to test this brand as it had good reviews. I’m very pleased with it and have recommended for lots of friends already!",
      "created_at": "2025-05-24T05:06:46.000Z",
      "verified_buyer": false,
      "reviewer": "Juliana",
      "product_handle": "boutique-extra-firm-mattress",
      "product_title": "Boutique Extra Firm Mattress",
      "tags": []
    },
    {
      "id": 517218834,
      "score": 5,
      "title": "Recommend",
      "content": "Excellent mattress",
      "created_at": "2023-10-27T02:14:26.000Z",
      "verified_buyer": false,
      "reviewer": "Dawei",
      "product_handle": "boutique-extra-firm-mattress",
      "product_title": "Boutique Extra Firm Mattress",
      "tags": []
    },
    {
      "id": 723763740,
      "score": 4,
      "title": "Speedy hassle free delivery. Early",
      "content": "Speedy hassle free delivery.\nEarly days but sleeping very well, great comfortable mattress",
      "created_at": "2025-06-30T23:19:52.000Z",
      "verified_buyer": true,
      "reviewer": "Graham P.",
      "product_handle": "boutique-extra-firm-mattress",
      "product_title": "Boutique Extra Firm Mattress",
      "tags": []
    },
    {
      "id": 841070802,
      "score": 4,
      "title": "Great quality, instant fix for my husband's back",
      "content": "My husband needs firm mattresses for his back, he is 160kg man who works physically demanding job. Our last mattress was good, but only lasted 2 years before he was having issues with it. We ordered this one and it was an instant fix for him! \n\nWe love the fact it's not zoned, we have the same support no matter where we lay on it. \n\nHowever, the mattress is a bit too firm for me, was giving me shoulder pain. I added a 3cm foam topper from spotlight and it's been perfect for both us.",
      "created_at": "2026-05-20T13:24:08.000Z",
      "verified_buyer": false,
      "reviewer": "Lara",
      "product_handle": "boutique-extra-firm-mattress",
      "product_title": "Boutique Extra Firm Mattress",
      "tags": [
        "hips",
        "partner",
        "value"
      ]
    },
    {
      "id": 747540389,
      "score": 5,
      "title": "Comfy and affordable!",
      "content": "This mattress is so comfy, I can’t believe we got such a good deal.",
      "created_at": "2025-08-24T02:22:48.000Z",
      "verified_buyer": true,
      "reviewer": "Lindsay P.",
      "product_handle": "boutique-mattress-memory-foam",
      "product_title": "Boutique Mattress",
      "tags": [
        "value"
      ]
    },
    {
      "id": 588052587,
      "score": 5,
      "title": "Perfect Budget mattress",
      "content": "It’s a fantastic medium firm mattress which does not put a hole in your pocket. Firmness is great and I feel really good with back sleeping and side sleeping. It was delivered in less than a day and was ready for sleeping within 24 hours.\nDefinitely recommend for everyone.",
      "created_at": "2024-06-06T09:19:54.000Z",
      "verified_buyer": true,
      "reviewer": "Ravi K.",
      "product_handle": "boutique-mattress-memory-foam",
      "product_title": "Boutique Mattress",
      "tags": [
        "hips"
      ]
    },
    {
      "id": 581839108,
      "score": 5,
      "title": "Great mattress",
      "content": "Had it for over a year and it's as good as any expensive mattress from local stores",
      "created_at": "2024-05-17T01:17:09.000Z",
      "verified_buyer": true,
      "reviewer": "Morgan",
      "product_handle": "boutique-mattress-memory-foam",
      "product_title": "Boutique Mattress",
      "tags": []
    },
    {
      "id": 568632898,
      "score": 5,
      "title": "Super comfortable!",
      "content": "This bed was recommended to me by my cousin and once I tried sleeping on hers I immediately bought it. Now moving into a new place and decided to get the same one but a bigger size. Highly recommend!",
      "created_at": "2024-04-09T01:14:48.000Z",
      "verified_buyer": true,
      "reviewer": "Sharon L.",
      "product_handle": "boutique-mattress-memory-foam",
      "product_title": "Boutique Mattress",
      "tags": []
    },
    {
      "id": 526831168,
      "score": 5,
      "title": "Nice mattress",
      "content": "This was my first time purchasing a mattress in a box. I decided to purchase this mattress based on the great reviews. This mattress is nice quality and very comfortable so far! The ordering and delivery process was easy.",
      "created_at": "2023-11-30T05:00:51.000Z",
      "verified_buyer": true,
      "reviewer": "Karen D.",
      "product_handle": "boutique-mattress-memory-foam",
      "product_title": "Boutique Mattress",
      "tags": [
        "box"
      ]
    },
    {
      "id": 504494570,
      "score": 5,
      "title": "Excellent quality and super comfortable",
      "content": "This was my first time purchasing a \"mattress in a box\" and I did a lot of research prior to taking the plunge. This mattress is amazing - incredible quality, very comfortable (more on the firm side), and so easy! I left it for 2 days once unwrapped prior to my daughter sleeping on it. The mattress has a nice depth and makes the linen/bedding look great.",
      "created_at": "2023-09-24T04:46:10.000Z",
      "verified_buyer": true,
      "reviewer": "Emily S.",
      "product_handle": "boutique-mattress-memory-foam",
      "product_title": "Boutique Mattress",
      "tags": [
        "kids",
        "box"
      ]
    },
    {
      "id": 499364007,
      "score": 5,
      "title": "Great Value for Money",
      "content": "We purchased this mattress for our spare bedroom and slept on it for a week while we were setting up our master. The mattress is just the right firmness and provides excellent back support. We are extremely impressed by the quality of this mattress and the value for money. We would highly recommend this mattress to anybody in the market for a value for money mattress.",
      "created_at": "2023-09-11T02:25:51.000Z",
      "verified_buyer": true,
      "reviewer": "Adam B.",
      "product_handle": "boutique-mattress-memory-foam",
      "product_title": "Boutique Mattress",
      "tags": [
        "value"
      ]
    },
    {
      "id": 495433099,
      "score": 5,
      "title": "Excellent mattress and great customer service",
      "content": "Really happy with my purchase and customer service. It arrived quick and even the company offered speedy redelivery with no additional fee. It took a good day to decompress. The mattress is really comfortable. It is just what I wanted from a firm mattress. I could have not bought better one. I would highly recommend this product!",
      "created_at": "2023-08-22T05:30:43.000Z",
      "verified_buyer": false,
      "reviewer": "Xuan-Hiep D.",
      "product_handle": "boutique-mattress-memory-foam",
      "product_title": "Boutique Mattress",
      "tags": []
    },
    {
      "id": 881995564,
      "score": 5,
      "title": "Comfy",
      "content": "Easily the most comfortable mattress I have ever slept on.",
      "created_at": "2026-08-17T01:30:49.000Z",
      "verified_buyer": true,
      "reviewer": "Jenny B.",
      "product_handle": "boutique-mattress-memory-foam",
      "product_title": "Boutique Mattress",
      "tags": []
    },
    {
      "id": 876702739,
      "score": 5,
      "title": "Very happy with my purchase",
      "content": "Very happy with my purchase mattress is very comfortable",
      "created_at": "2026-08-03T10:57:17.000Z",
      "verified_buyer": true,
      "reviewer": "Garry B.",
      "product_handle": "boutique-mattress-memory-foam",
      "product_title": "Boutique Mattress",
      "tags": []
    },
    {
      "id": 860074382,
      "score": 5,
      "title": "Very happywith my purchase",
      "content": "Timely delivery. Easy to set up. Great quality materials and solid mattress. Comfortable. Would order again. A very convenient way to buy a great mattress.",
      "created_at": "2026-06-20T00:02:31.000Z",
      "verified_buyer": true,
      "reviewer": "Kat",
      "product_handle": "boutique-mattress-memory-foam",
      "product_title": "Boutique Mattress",
      "tags": []
    },
    {
      "id": 845473888,
      "score": 5,
      "title": "Great quality, fast delivery,",
      "content": "The mattress is very comfortable at a very affordable price. Delivery was very quick too. Very happy.",
      "created_at": "2026-05-31T03:38:51.000Z",
      "verified_buyer": true,
      "reviewer": "Pixie",
      "product_handle": "boutique-mattress-memory-foam",
      "product_title": "Boutique Mattress",
      "tags": [
        "value"
      ]
    },
    {
      "id": 837585371,
      "score": 5,
      "title": "Great value, speedy delivery and very comfy",
      "content": "3x the value compared to a sleeping duck mattress. We have both and we cannot tell the difference. I highly recommend Mattress Crafters, we have purchased 2 now.",
      "created_at": "2026-05-09T07:04:05.000Z",
      "verified_buyer": true,
      "reviewer": "Kelly L.",
      "product_handle": "boutique-mattress-memory-foam",
      "product_title": "Boutique Mattress",
      "tags": []
    },
    {
      "id": 809283062,
      "score": 5,
      "title": "Not used yet",
      "content": "Not used yet",
      "created_at": "2026-02-11T22:25:29.000Z",
      "verified_buyer": true,
      "reviewer": "Carolyn C.",
      "product_handle": "boutique-mattress-memory-foam",
      "product_title": "Boutique Mattress",
      "tags": []
    },
    {
      "id": 803249137,
      "score": 5,
      "title": "Fantastic mattress for the price",
      "content": "I bought the Boutique Mattress for a guest bedroom as I didn't want to spend too much money, but I still want my guests to be comfortable. After checking various comparison sites I purchased this one as it was rated very highly. I also like that it's made in Australia by an Australian company. You wouldn't know that it's a lower priced mattress and my recent guest commented how comfortable she found it. I would highly recommend this mattress and Mattress Crafters",
      "created_at": "2026-01-28T20:21:06.000Z",
      "verified_buyer": true,
      "reviewer": "Layla M.",
      "product_handle": "boutique-mattress-memory-foam",
      "product_title": "Boutique Mattress",
      "tags": [
        "kids",
        "value"
      ]
    },
    {
      "id": 802806867,
      "score": 5,
      "title": "Very comfortable. I have purchased",
      "content": "Very comfortable. I have purchased 3 mattresses from this company and have been 100% satisfied with the product, price and delivery. Highly recommended.",
      "created_at": "2026-01-27T10:34:00.000Z",
      "verified_buyer": true,
      "reviewer": "Maria D.",
      "product_handle": "boutique-mattress-memory-foam",
      "product_title": "Boutique Mattress",
      "tags": [
        "value"
      ]
    },
    {
      "id": 800713282,
      "score": 5,
      "title": "Very satisfied",
      "content": "Very happy with my new mattress – my previous one gave me discomfort and stiffness in the lower back on waking up. Now I am more mobile and free of discomfort on waking. Bill",
      "created_at": "2026-01-20T10:29:33.000Z",
      "verified_buyer": true,
      "reviewer": "Bill",
      "product_handle": "boutique-mattress-memory-foam",
      "product_title": "Boutique Mattress",
      "tags": [
        "back"
      ]
    },
    {
      "id": 789034135,
      "score": 5,
      "title": "Mattress.",
      "content": "Extremely happy with the prompt delivery and quality of mattress. 💁‍♀️",
      "created_at": "2025-12-10T02:47:36.000Z",
      "verified_buyer": true,
      "reviewer": "Julie J.",
      "product_handle": "boutique-mattress-memory-foam",
      "product_title": "Boutique Mattress",
      "tags": []
    },
    {
      "id": 784045338,
      "score": 5,
      "title": "Great mattress at a great price",
      "content": "After reading all the reviews I decided to purchase this mattress for my spare bed. I slept on it for a couple of nights to try it out. I have had back trouble but I got up each morning feeling great. I have decided to buy another mattress \nfor my own bed.",
      "created_at": "2025-11-21T20:57:51.000Z",
      "verified_buyer": true,
      "reviewer": "Julie",
      "product_handle": "boutique-mattress-memory-foam",
      "product_title": "Boutique Mattress",
      "tags": [
        "partner",
        "value"
      ]
    },
    {
      "id": 779068875,
      "score": 5,
      "title": "QS Boutique Mattress",
      "content": "It’s my first time buying a mattress in a box. I proceeded to do so after reading the reviews. It is for my spare room. It was such a surprise to see a quality mattress pop out of the box. Myself & family members tried it for comfort & were very pleased with. Not too hard, not too soft, my Goldilocks mattress. Very fast delivery and very pleasant delivery lady. This mattress is great value. My daughter is now going to purchase one.",
      "created_at": "2025-11-12T01:25:56.000Z",
      "verified_buyer": true,
      "reviewer": "Heather S.",
      "product_handle": "boutique-mattress-memory-foam",
      "product_title": "Boutique Mattress",
      "tags": [
        "kids",
        "box"
      ]
    },
    {
      "id": 764801846,
      "score": 5,
      "title": "Boutique Mattress",
      "content": "A couple of weeks in, and I can easily say this is the best mattress I have ever slept on. Firm without being hard, and a nice upper layer that just works.\n\nI am very happy that I read all the reviews out there to come to this decision (Bedbuyers 2025 awards stood out).\n\nAlready another purchase is on the horizon fo another family member :).",
      "created_at": "2025-09-29T05:41:15.000Z",
      "verified_buyer": true,
      "reviewer": "Pete R.",
      "product_handle": "boutique-mattress-memory-foam",
      "product_title": "Boutique Mattress",
      "tags": [
        "partner"
      ]
    },
    {
      "id": 735796147,
      "score": 5,
      "title": "Good mattress, firm and comfortable",
      "content": "Good mattress, firm and comfortable",
      "created_at": "2025-08-08T06:52:37.000Z",
      "verified_buyer": true,
      "reviewer": "Mariusz D.",
      "product_handle": "boutique-mattress-memory-foam",
      "product_title": "Boutique Mattress",
      "tags": []
    },
    {
      "id": 726404427,
      "score": 5,
      "title": "Ok so far",
      "content": "Well, After 1 night's sleep - it works. Way too early to properly review a mattress. Call us later.",
      "created_at": "2025-07-09T09:48:00.000Z",
      "verified_buyer": true,
      "reviewer": "Chris",
      "product_handle": "boutique-mattress-memory-foam",
      "product_title": "Boutique Mattress",
      "tags": []
    },
    {
      "id": 718023781,
      "score": 5,
      "title": "Happy with my new mattress! :)",
      "content": "I'm enjoying my new MC Mattress. Although it feels less firm to me than the reviews suggested, the improvement in quality compared to my old one is significant, and I'm now having restful nights.\n\nWe had a small issue with the courier not providing any updates about the delivery process, but Bianca was amazing—she followed up for us, gave us peace of mind, and provided an accurate ETA, just as promised. Thank you, Bianca and the TC Team!",
      "created_at": "2025-06-14T07:09:08.000Z",
      "verified_buyer": true,
      "reviewer": "Florencia S.",
      "product_handle": "boutique-mattress-memory-foam",
      "product_title": "Boutique Mattress",
      "tags": []
    },
    {
      "id": 687382129,
      "score": 5,
      "title": "Yes i am happy with",
      "content": "Yes i am happy with my mattress so far and very happy how quickly i received thank you",
      "created_at": "2025-03-10T01:13:51.000Z",
      "verified_buyer": true,
      "reviewer": "Veronica C.",
      "product_handle": "boutique-mattress-memory-foam",
      "product_title": "Boutique Mattress",
      "tags": []
    },
    {
      "id": 645132610,
      "score": 5,
      "title": "Sleeping like a baby!",
      "content": "Excellent service, great price and the mattress is super comfy.",
      "created_at": "2024-11-04T08:27:52.000Z",
      "verified_buyer": true,
      "reviewer": "Dave",
      "product_handle": "boutique-mattress-memory-foam",
      "product_title": "Boutique Mattress",
      "tags": [
        "value"
      ]
    },
    {
      "id": 634284534,
      "score": 5,
      "title": "Great value mattress",
      "content": "I purchased one of these mattresses and was so happy with it I purchased another two. They are comfortable, supportive and great value for money.\nHighly recommended!",
      "created_at": "2024-10-06T23:38:12.000Z",
      "verified_buyer": true,
      "reviewer": "Clinton R.",
      "product_handle": "boutique-mattress-memory-foam",
      "product_title": "Boutique Mattress",
      "tags": [
        "value"
      ]
    },
    {
      "id": 631908312,
      "score": 5,
      "title": "The Sandmans Playground",
      "content": "Top notch from start to finish. The Zs are pumping on this bad boy 💤😴",
      "created_at": "2024-09-29T14:31:55.000Z",
      "verified_buyer": true,
      "reviewer": "Gee B.",
      "product_handle": "boutique-mattress-memory-foam",
      "product_title": "Boutique Mattress",
      "tags": []
    },
    {
      "id": 614570972,
      "score": 5,
      "title": "Great Mattress at a great price",
      "content": "This is the mattress we keep coming back to, comfortable, reliable people pleaser.",
      "created_at": "2024-08-25T23:12:05.000Z",
      "verified_buyer": true,
      "reviewer": "Bronwyn D.",
      "product_handle": "boutique-mattress-memory-foam",
      "product_title": "Boutique Mattress",
      "tags": [
        "value"
      ]
    },
    {
      "id": 614371784,
      "score": 5,
      "title": "Noice",
      "content": "Comfy and firm but not painful",
      "created_at": "2024-08-24T11:12:07.000Z",
      "verified_buyer": true,
      "reviewer": "Chris G.",
      "product_handle": "boutique-mattress-memory-foam",
      "product_title": "Boutique Mattress",
      "tags": []
    },
    {
      "id": 614228463,
      "score": 5,
      "title": "Perfect",
      "content": "Good quality, comfortable and well made",
      "created_at": "2024-08-23T23:05:00.000Z",
      "verified_buyer": true,
      "reviewer": "Craig B.",
      "product_handle": "boutique-mattress-memory-foam",
      "product_title": "Boutique Mattress",
      "tags": []
    },
    {
      "id": 610558583,
      "score": 5,
      "title": "Exceptional Comfort, Support, and Value - Exceeded Expectations!",
      "content": "We purchased two Boutique Mattresses from Mattress Crafters for our guest bedrooms, and we're thrilled with the experience! The delivery was incredibly fast, and the mattresses were super comfortable right from the start.\n\nWhat surprised us most was the level of support these mattresses provide. Our guests have consistently praised the comfort and quality of the mattresses, and we've received countless compliments on the great value for the price.\n\nThe Boutique Mattress has exceeded our expectations in every way.",
      "created_at": "2024-08-14T09:46:10.000Z",
      "verified_buyer": true,
      "reviewer": "My T.",
      "product_handle": "boutique-mattress-memory-foam",
      "product_title": "Boutique Mattress",
      "tags": [
        "kids",
        "value"
      ]
    },
    {
      "id": 599598390,
      "score": 5,
      "title": "Very pleased with this mattress",
      "content": "Very pleased with this mattress and the prompt delivery was very much appreciated",
      "created_at": "2024-07-16T02:32:18.000Z",
      "verified_buyer": true,
      "reviewer": "Rita W.",
      "product_handle": "boutique-mattress-memory-foam",
      "product_title": "Boutique Mattress",
      "tags": []
    },
    {
      "id": 595125101,
      "score": 5,
      "title": "She loves to sleep!",
      "content": "Purchased mattress in January 2024. Seamless delivery. Mattress very comfortable. Not too firm or too soft. Highly recommended. So good I bought a second one.",
      "created_at": "2024-06-30T10:43:26.000Z",
      "verified_buyer": true,
      "reviewer": "Elokin H.",
      "product_handle": "boutique-mattress-memory-foam",
      "product_title": "Boutique Mattress",
      "tags": []
    },
    {
      "id": 584950069,
      "score": 5,
      "title": "Just love it!",
      "content": "We grabbed a mattress for our son and loved it so much will get one for ourselves. \n\nP.S. Delivery was super fast!",
      "created_at": "2024-05-27T06:04:11.000Z",
      "verified_buyer": true,
      "reviewer": "Daniel A.",
      "product_handle": "boutique-mattress-memory-foam",
      "product_title": "Boutique Mattress",
      "tags": [
        "kids"
      ]
    },
    {
      "id": 582028542,
      "score": 5,
      "title": "Puts me to sleep almost instantly",
      "content": "Honestly did not expect a boxed mattress to be so comfy. It's nice and firm, I feel properly supported lying on it, and it certainly doesn't feel like you're bouncing and creaking on springs. It almost feels better than a $2000+ Sealy mattress, although can't say what it's like in the long run (I've only had it for two weeks). Such a great price too.",
      "created_at": "2024-05-17T07:21:10.000Z",
      "verified_buyer": true,
      "reviewer": "Stephanie",
      "product_handle": "boutique-mattress-memory-foam",
      "product_title": "Boutique Mattress",
      "tags": [
        "value"
      ]
    },
    {
      "id": 576460166,
      "score": 5,
      "title": "Goldilocks comfort best budget mattress!",
      "content": "Top value for quality mattress with excellent all round reviews and recommendations \nSuper fast delivery \nEasy ordering - very happy!",
      "created_at": "2024-04-27T20:28:39.000Z",
      "verified_buyer": true,
      "reviewer": "Anne i.",
      "product_handle": "boutique-mattress-memory-foam",
      "product_title": "Boutique Mattress",
      "tags": []
    },
    {
      "id": 563794501,
      "score": 5,
      "title": "Great Mattress & Super Fast Delivery",
      "content": "Ordered mattress one day received the next. \nGreat comfortable mattress which visitors to our holiday house love.\nWil be purchasing a second Boutique mattress for another bedroom.",
      "created_at": "2024-04-02T23:48:21.000Z",
      "verified_buyer": true,
      "reviewer": "Bryan H.",
      "product_handle": "boutique-mattress-memory-foam",
      "product_title": "Boutique Mattress",
      "tags": []
    },
    {
      "id": 556843758,
      "score": 5,
      "title": "Great bed at a great price",
      "content": "I was concerned about buying a cheaper bed without knowing the quality. But this bed surprised us. Very comfortable, quick delivery and a fantastic price.",
      "created_at": "2024-03-16T20:45:23.000Z",
      "verified_buyer": true,
      "reviewer": "Natasha E.",
      "product_handle": "boutique-mattress-memory-foam",
      "product_title": "Boutique Mattress",
      "tags": [
        "value"
      ]
    },
    {
      "id": 551816765,
      "score": 5,
      "title": "Brilliant mattress",
      "content": "I have several boutique mattresses. Very comfortable and excellent quality, especially when considering the price. Fast delivery is a bonus. Several of my family and friends have now bought this mattress after sleeping on it themselves or via my recommendation.",
      "created_at": "2024-03-01T08:42:08.000Z",
      "verified_buyer": true,
      "reviewer": "Audrey C.",
      "product_handle": "boutique-mattress-memory-foam",
      "product_title": "Boutique Mattress",
      "tags": [
        "value"
      ]
    },
    {
      "id": 541642825,
      "score": 5,
      "title": "super comfy",
      "content": "I got a King Single mattress for my 14 year old, and he is really happy with it. I had a good feel of it and it is so nice and supportive without being really firm or overly soft.",
      "created_at": "2024-02-04T13:47:18.000Z",
      "verified_buyer": true,
      "reviewer": "Melanie R.",
      "product_handle": "boutique-mattress-memory-foam",
      "product_title": "Boutique Mattress",
      "tags": []
    },
    {
      "id": 540493219,
      "score": 5,
      "title": "comfy and popular",
      "content": "Easy to buy, fairly easy to open, very comfortable sleep. Can't keep my children off the bed now, they think its their new couch. Happy with the firmness/comfort of this matress.",
      "created_at": "2024-01-30T02:04:01.000Z",
      "verified_buyer": true,
      "reviewer": "Simon B.",
      "product_handle": "boutique-mattress-memory-foam",
      "product_title": "Boutique Mattress",
      "tags": [
        "kids"
      ]
    },
    {
      "id": 534991633,
      "score": 5,
      "title": "Sound purchase",
      "content": "Very comfortable mattress for the money! Not to firm, not to plush just right!",
      "created_at": "2024-01-04T22:51:13.000Z",
      "verified_buyer": true,
      "reviewer": "Paul T.",
      "product_handle": "boutique-mattress-memory-foam",
      "product_title": "Boutique Mattress",
      "tags": [
        "value"
      ]
    },
    {
      "id": 523637731,
      "score": 5,
      "title": "Great value, very comfortable",
      "content": "The mattress arrived on time as promised and is very comfortable. It is in my guest bedroom and they liked it. It feels like a much more expensive mattress.",
      "created_at": "2023-11-16T00:17:11.000Z",
      "verified_buyer": true,
      "reviewer": "Bruce C.",
      "product_handle": "boutique-mattress-memory-foam",
      "product_title": "Boutique Mattress",
      "tags": [
        "kids"
      ]
    },
    {
      "id": 507982618,
      "score": 5,
      "title": "Best customer service ever!",
      "content": "I bought two mattresses and they both are more than amazing!\nOne of them was pre-order so it git delivered one or two weeks after the other one and all that ive been emailing them checking for updates and asking for rescheduling and they have been more than amazing honestly the best customer service i have ever dealt with!",
      "created_at": "2023-10-06T11:54:49.000Z",
      "verified_buyer": true,
      "reviewer": "Cinderella E.",
      "product_handle": "boutique-mattress-memory-foam",
      "product_title": "Boutique Mattress",
      "tags": []
    },
    {
      "id": 503151115,
      "score": 5,
      "title": "Excellent value and comfort",
      "content": "The mattress is very comfortable thanks to the hybrid design. It was delivered very fast and in the month I've had it I have been sleeping so much better. Absolutely recommend!",
      "created_at": "2023-09-21T05:55:50.000Z",
      "verified_buyer": true,
      "reviewer": "Adam P.",
      "product_handle": "boutique-mattress-memory-foam",
      "product_title": "Boutique Mattress",
      "tags": []
    },
    {
      "id": 497771172,
      "score": 5,
      "title": "Was looking for ages for",
      "content": "Was looking for ages for the best value for money as this mattress was for my mother and im happy she loves it I'm very happy I went with the boutique from mattress crafters Australia it cam early super plush and perfect for her motorised bed 👍👍 thanks guys",
      "created_at": "2023-09-03T11:53:54.000Z",
      "verified_buyer": true,
      "reviewer": "Anthony B.",
      "product_handle": "boutique-mattress-memory-foam",
      "product_title": "Boutique Mattress",
      "tags": [
        "older",
        "value"
      ]
    },
    {
      "id": 497770791,
      "score": 5,
      "title": "Boutique Mattress - Memory Foam + Pocket Spring",
      "content": "Fabulous mattress and very comfortable. Quick delivery and great service. Very Happy",
      "created_at": "2023-09-03T11:48:04.000Z",
      "verified_buyer": true,
      "reviewer": "Connie C.",
      "product_handle": "boutique-mattress-memory-foam",
      "product_title": "Boutique Mattress",
      "tags": []
    },
    {
      "id": 497527387,
      "score": 5,
      "title": "This mattress is so comfy,",
      "content": "This mattress is so comfy, just don’t want to get out of bed!",
      "created_at": "2023-09-01T10:24:08.000Z",
      "verified_buyer": true,
      "reviewer": "Tracey F.",
      "product_handle": "boutique-mattress-memory-foam",
      "product_title": "Boutique Mattress",
      "tags": []
    },
    {
      "id": 470760976,
      "score": 5,
      "title": "Very good quality at an",
      "content": "Very good quality at an affordable price. Very happy.",
      "created_at": "2023-05-21T02:42:28.000Z",
      "verified_buyer": true,
      "reviewer": "Linda D.",
      "product_handle": "boutique-mattress-memory-foam",
      "product_title": "Boutique Mattress",
      "tags": [
        "value"
      ]
    },
    {
      "id": 467526739,
      "score": 5,
      "title": "mattress",
      "content": "Happy with my purchase, just what I wanted, firm edge and firm mattress. Could have not bought better.",
      "created_at": "2023-05-06T02:49:55.000Z",
      "verified_buyer": true,
      "reviewer": "Dieter D.",
      "product_handle": "boutique-mattress-memory-foam",
      "product_title": "Boutique Mattress",
      "tags": []
    },
    {
      "id": 447195027,
      "score": 5,
      "title": "Good product, great service.",
      "content": "Comfortable, great price and free delivery. Very happy! Why pay more when you can get better for less?",
      "created_at": "2023-02-23T05:35:27.000Z",
      "verified_buyer": true,
      "reviewer": "Dave R.",
      "product_handle": "boutique-mattress-memory-foam",
      "product_title": "Boutique Mattress",
      "tags": [
        "value"
      ]
    },
    {
      "id": 432572142,
      "score": 5,
      "title": "Excellent value for money!",
      "content": "Excellent mattress considering we bought it on special. Firm without feeling too hard. Definitely able to feel less tossing and turning from bed partner. Would highly recommend!",
      "created_at": "2023-01-17T23:15:59.000Z",
      "verified_buyer": true,
      "reviewer": "Leanne A.",
      "product_handle": "boutique-mattress-memory-foam",
      "product_title": "Boutique Mattress",
      "tags": [
        "partner",
        "value"
      ]
    },
    {
      "id": 430447546,
      "score": 5,
      "title": "So far so good ! Excellent value",
      "content": "Bought 2 for my 2 teenage kids \nSuper fast delivery ( next day ) We are rotating mattress every 2 weeks first 3 months and made sure all bed frames meet requirements so hopefully we get many yrs of use .",
      "created_at": "2023-01-07T06:34:16.000Z",
      "verified_buyer": true,
      "reviewer": "Luke R.",
      "product_handle": "boutique-mattress-memory-foam",
      "product_title": "Boutique Mattress",
      "tags": [
        "kids"
      ]
    },
    {
      "id": 429950460,
      "score": 5,
      "title": "Great price , great mattress",
      "content": "Bought 4 of these mattresses for our new rental property, they arrived on time and for the price they are an excellent mattress. They take a good day to decompress and then about 3-4 sleeps to soften and bed in but after that it’s a VERY good Mattress for what you pay. Bruce in customer service is also excellent if you have any issues or postage problems.",
      "created_at": "2023-01-04T19:37:06.000Z",
      "verified_buyer": true,
      "reviewer": "pete h.",
      "product_handle": "boutique-mattress-memory-foam",
      "product_title": "Boutique Mattress",
      "tags": [
        "value"
      ]
    },
    {
      "id": 424472195,
      "score": 5,
      "title": "Happy customer",
      "content": "Happy customer",
      "created_at": "2022-12-12T00:57:26.000Z",
      "verified_buyer": true,
      "reviewer": "Kee N.",
      "product_handle": "boutique-mattress-memory-foam",
      "product_title": "Boutique Mattress",
      "tags": []
    },
    {
      "id": 423766089,
      "score": 5,
      "title": "Turns out it was a good but.",
      "content": "I waited a fair amount of time so as to be able to write an appropriate review. The mattress, certainly for the price, is excellent and recommended.",
      "created_at": "2022-12-08T02:40:23.000Z",
      "verified_buyer": true,
      "reviewer": "Greg B.",
      "product_handle": "boutique-mattress-memory-foam",
      "product_title": "Boutique Mattress",
      "tags": [
        "value"
      ]
    },
    {
      "id": 421614876,
      "score": 5,
      "title": "Comfy, quality mattress.",
      "content": "Great value and a really comfy mattress. Service and delivery was excellent.",
      "created_at": "2022-11-29T04:40:27.000Z",
      "verified_buyer": true,
      "reviewer": "MEGAN W.",
      "product_handle": "boutique-mattress-memory-foam",
      "product_title": "Boutique Mattress",
      "tags": []
    },
    {
      "id": 421158726,
      "score": 5,
      "title": "Excellent Mattress at very competitive price!",
      "content": "Don't let the lower price range fool you, this mattress is excellent. Delivery was swift as well.",
      "created_at": "2022-11-26T07:08:46.000Z",
      "verified_buyer": true,
      "reviewer": "Emilio K.",
      "product_handle": "boutique-mattress-memory-foam",
      "product_title": "Boutique Mattress",
      "tags": [
        "value"
      ]
    },
    {
      "id": 420578951,
      "score": 5,
      "title": "Very happy!",
      "content": "Whilst this was not my original order, due to a stock hold up, I am very happy with it. Great communication meant that I was able to have a mattress sooner than later and I was promised the mattress was the same in every way. I am so impressed that a mattress that arrives in a box could be this good!! It's firm but comfortable and has strong sidewalls which can be a problem with other mattress in a box. Anyway, this one is quite firm so make sure you understand that when you order.",
      "created_at": "2022-11-23T09:29:48.000Z",
      "verified_buyer": true,
      "reviewer": "Darren W.",
      "product_handle": "boutique-mattress-memory-foam",
      "product_title": "Boutique Mattress",
      "tags": [
        "box"
      ]
    },
    {
      "id": 418837289,
      "score": 5,
      "title": "Great value",
      "content": "As good as anything else out there at a much better price",
      "created_at": "2022-11-16T20:53:44.000Z",
      "verified_buyer": true,
      "reviewer": "Cathrine P.",
      "product_handle": "boutique-mattress-memory-foam",
      "product_title": "Boutique Mattress",
      "tags": [
        "value"
      ]
    },
    {
      "id": 405620806,
      "score": 5,
      "title": "Comfortable and fast delivery",
      "content": "Comfortable and fast delivery (arrived same day!)",
      "created_at": "2022-09-25T03:52:10.000Z",
      "verified_buyer": true,
      "reviewer": "Daniel B.",
      "product_handle": "boutique-mattress-memory-foam",
      "product_title": "Boutique Mattress",
      "tags": []
    },
    {
      "id": 400056194,
      "score": 5,
      "title": "Very good",
      "content": "Easy to unpack, quick delivery. Very comfortable",
      "created_at": "2022-09-07T06:56:51.000Z",
      "verified_buyer": true,
      "reviewer": "Justin T.",
      "product_handle": "boutique-mattress-memory-foam",
      "product_title": "Boutique Mattress",
      "tags": []
    },
    {
      "id": 389441246,
      "score": 5,
      "title": "Surprised by the quality",
      "content": "The cost was very reasonable; the reviews were good so took a chance and bought the mattress. I have not regretted the decision. It arrive quickly in a box and it was easy to unwrap. The comfort was very surprising and would definitely recommend.",
      "created_at": "2022-08-01T00:14:14.000Z",
      "verified_buyer": true,
      "reviewer": "Meaghan P.",
      "product_handle": "boutique-mattress-memory-foam",
      "product_title": "Boutique Mattress",
      "tags": [
        "kids",
        "box"
      ]
    },
    {
      "id": 357759660,
      "score": 5,
      "title": "Great Overall Experience",
      "content": "Fast delivery, good price and the bed is very comfortable especially the reduced partner disruption feature.",
      "created_at": "2022-04-17T22:48:09.000Z",
      "verified_buyer": true,
      "reviewer": "jeff l.",
      "product_handle": "boutique-mattress-memory-foam",
      "product_title": "Boutique Mattress",
      "tags": [
        "partner",
        "value"
      ]
    },
    {
      "id": 357362424,
      "score": 5,
      "title": "Very good mattress , comfortable",
      "content": "Very good mattress , comfortable and love the 15 year warranty.",
      "created_at": "2022-04-15T23:52:18.000Z",
      "verified_buyer": true,
      "reviewer": "Tony N.",
      "product_handle": "boutique-mattress-memory-foam",
      "product_title": "Boutique Mattress",
      "tags": []
    },
    {
      "id": 645186011,
      "score": 5,
      "title": "Service based business.",
      "content": "Great to work with, had to reschedule delivery and no problem at all.\nGreat product, great customer service.\nThanks team",
      "created_at": "2024-11-04T12:39:37.000Z",
      "verified_buyer": false,
      "reviewer": "Geoff",
      "product_handle": "boutique-mattress-memory-foam",
      "product_title": "Boutique Mattress",
      "tags": []
    },
    {
      "id": 640747504,
      "score": 5,
      "title": "Comfortable from Day 1",
      "content": "Pleasantly surprised with this King size mattress. Comfortable from Day 1 with us both sleeping a solid 8 hrs the first and subsequent nights, Good instructions that were easy to follow. Will be purchasing from this company again.",
      "created_at": "2024-10-22T10:16:07.000Z",
      "verified_buyer": false,
      "reviewer": "Jenny D.",
      "product_handle": "boutique-mattress-memory-foam",
      "product_title": "Boutique Mattress",
      "tags": []
    },
    {
      "id": 575793336,
      "score": 5,
      "title": "Fast delivery",
      "content": "Very fast delivery :) not try the mattress yet",
      "created_at": "2024-04-25T11:33:26.000Z",
      "verified_buyer": false,
      "reviewer": "Candy",
      "product_handle": "boutique-mattress-memory-foam",
      "product_title": "Boutique Mattress",
      "tags": []
    },
    {
      "id": 533939732,
      "score": 5,
      "title": "It was the most comfortable sleep !",
      "content": "Had the best sleep in a long time! So comfortable and doesn’t sink.",
      "created_at": "2023-12-30T17:41:20.000Z",
      "verified_buyer": false,
      "reviewer": "Leenah",
      "product_handle": "boutique-mattress-memory-foam",
      "product_title": "Boutique Mattress",
      "tags": []
    },
    {
      "id": 529679395,
      "score": 5,
      "title": "Great mattress at a great price!",
      "content": "Bought a double for my tween about 6 months ago. She loves it and it is very comfortable. Hadn't bought a mattress in a box before but was sold on the price. No regrets, and now planning to buy one for my son. Delivery and set-up very straightforward.",
      "created_at": "2023-12-11T11:35:40.000Z",
      "verified_buyer": false,
      "reviewer": "Katrina B.",
      "product_handle": "boutique-mattress-memory-foam",
      "product_title": "Boutique Mattress",
      "tags": [
        "kids",
        "box",
        "value"
      ]
    },
    {
      "id": 500999701,
      "score": 5,
      "title": "Firm and supportive and fast delivery,",
      "content": "Ordered this around 10pm and it was delivered the next day before 2pm. Amazing! Thank you. \nLeft it to decompress for 24 hours and am sleeping on it now. I prefer a firm mattress so this fits the bill. It is somehow firm and supportive and cushiony all at once. First time sleeping in a king after queen, and I am kicking myself that I didn’t make the jump sooner. \nI will certainly be a return customer for their quilts and pillowcases and to set up my son’s bed.",
      "created_at": "2023-09-15T07:48:00.000Z",
      "verified_buyer": false,
      "reviewer": "V.W",
      "product_handle": "boutique-mattress-memory-foam",
      "product_title": "Boutique Mattress",
      "tags": [
        "kids"
      ]
    },
    {
      "id": 483548415,
      "score": 5,
      "title": "Awesome Mattress",
      "content": "Excellent mattress. Exceeded expectations. So comfortable and great value. Will 100% buy again.",
      "created_at": "2023-07-16T20:28:18.000Z",
      "verified_buyer": false,
      "reviewer": "Lisa",
      "product_handle": "boutique-mattress-memory-foam",
      "product_title": "Boutique Mattress",
      "tags": []
    },
    {
      "id": 482261816,
      "score": 5,
      "title": "Excellent value",
      "content": "Great mattress despite the retail stores telling us boxed mattresses were greatly inferior. Just the right feel, no partner disturbance. Delivery to our regional area in just 3 days and no delivery charge. Great value at 40% of the retail store price!",
      "created_at": "2023-07-10T07:55:39.000Z",
      "verified_buyer": false,
      "reviewer": "Graham O.",
      "product_handle": "boutique-mattress-memory-foam",
      "product_title": "Boutique Mattress",
      "tags": [
        "partner",
        "value"
      ]
    },
    {
      "id": 745874757,
      "score": 5,
      "title": "Amazing",
      "content": "The bed is very comfortable well-made and I am having the best night sleep on it",
      "created_at": "2025-08-21T00:40:34.000Z",
      "verified_buyer": false,
      "reviewer": "Adam D.",
      "product_handle": "boutique-mattress-memory-foam",
      "product_title": "Boutique Mattress",
      "tags": []
    },
    {
      "id": 314189399,
      "score": 5,
      "title": "Speedy service so comfy helps",
      "content": "Speedy service so comfy helps with painful neck stress",
      "created_at": "2021-11-19T00:00:00.000Z",
      "verified_buyer": false,
      "reviewer": "Cass",
      "product_handle": "boutique-mattress-memory-foam",
      "product_title": "Boutique Mattress",
      "tags": []
    },
    {
      "id": 302456079,
      "score": 5,
      "title": "Good quality and fit thanks",
      "content": "Good quality and fit thanks",
      "created_at": "2021-10-10T00:00:00.000Z",
      "verified_buyer": false,
      "reviewer": "ymmblue",
      "product_handle": "boutique-mattress-memory-foam",
      "product_title": "Boutique Mattress",
      "tags": []
    },
    {
      "id": 674127524,
      "score": 4,
      "title": "King single mattress",
      "content": "This company is super efficient and transparant to deal with. The mattress was delivered next day, and when I made a mistake with my order, they got straight back to me and fixed it with no fuss. Great comfortable mattress for a great price. Highly recommend this mattress and company to deal with.",
      "created_at": "2025-01-29T00:20:35.000Z",
      "verified_buyer": true,
      "reviewer": "Zoe N.",
      "product_handle": "boutique-mattress-memory-foam",
      "product_title": "Boutique Mattress",
      "tags": [
        "value"
      ]
    },
    {
      "id": 665687338,
      "score": 4,
      "title": "Mattress",
      "content": "Very firm and comfortable",
      "created_at": "2025-01-06T13:57:29.000Z",
      "verified_buyer": true,
      "reviewer": "LIZ R.",
      "product_handle": "boutique-mattress-memory-foam",
      "product_title": "Boutique Mattress",
      "tags": []
    },
    {
      "id": 576255582,
      "score": 4,
      "title": "Promptly received not tried yet.",
      "content": "We ordered this mattress for the guest bedroom, its not been tried yet.\nDelivery was on time.",
      "created_at": "2024-04-26T23:20:23.000Z",
      "verified_buyer": true,
      "reviewer": "Divyesh S.",
      "product_handle": "boutique-mattress-memory-foam",
      "product_title": "Boutique Mattress",
      "tags": [
        "kids"
      ]
    },
    {
      "id": 469153465,
      "score": 4,
      "title": "Boutique Mattress",
      "content": "Just purchased this mattress for our spare room and seems to be really good value. \nVery happy so far and would definitely recommend for the price.",
      "created_at": "2023-05-13T06:56:40.000Z",
      "verified_buyer": true,
      "reviewer": "Karen R.",
      "product_handle": "boutique-mattress-memory-foam",
      "product_title": "Boutique Mattress",
      "tags": [
        "kids",
        "value"
      ]
    },
    {
      "id": 443362433,
      "score": 4,
      "title": "Early days, but seems to be good value for money",
      "content": "Pretty fast delivery, pretty hassle free purchase, seems a pretty good mattress especially at that price. Happy to recommend.",
      "created_at": "2023-02-16T10:38:03.000Z",
      "verified_buyer": true,
      "reviewer": "Scott S.",
      "product_handle": "boutique-mattress-memory-foam",
      "product_title": "Boutique Mattress",
      "tags": [
        "value"
      ]
    },
    {
      "id": 426186113,
      "score": 4,
      "title": "Good for price",
      "content": "Delivery Good, Had it for 2 months Mattress OK (Sags on edges a bit). Comfortable mattress for the price.",
      "created_at": "2022-12-18T21:54:45.000Z",
      "verified_buyer": true,
      "reviewer": "Timothy N.",
      "product_handle": "boutique-mattress-memory-foam",
      "product_title": "Boutique Mattress",
      "tags": [
        "value"
      ]
    },
    {
      "id": 419716614,
      "score": 4,
      "title": "Boutique Mattress",
      "content": "Initial impressions are very good. I was surprised at how comfortable a mattress in a box could be.",
      "created_at": "2022-11-19T21:13:16.000Z",
      "verified_buyer": true,
      "reviewer": "Brett P.",
      "product_handle": "boutique-mattress-memory-foam",
      "product_title": "Boutique Mattress",
      "tags": [
        "box"
      ]
    },
    {
      "id": 802697091,
      "score": 3,
      "title": "Firmer than expected",
      "content": "I have back problems and was experiencing problems with pressure points on my hips with my old mattress so I decided to upgrade to a new one. Unfortunately the Boutique mattress is firmer than I expected and I still get occasional pressure point discomfort. It may be more suitable for a back sleeper rather than a side sleeper.",
      "created_at": "2026-01-26T22:57:56.000Z",
      "verified_buyer": true,
      "reviewer": "Gwen C.",
      "product_handle": "boutique-mattress-memory-foam",
      "product_title": "Boutique Mattress",
      "tags": [
        "hips"
      ]
    },
    {
      "id": 526814139,
      "score": 2,
      "title": "Unfit for us",
      "content": "After creating a list of beds to test, we decided to try this bed out first after reading reviews on Bed Buyer site for mattresses in a box.\n\nAfter completing the trial period, my wife complained of a sore back and neck and I could feel the springs when I laid on my side, so we reached out to return it and was told of the shipping to and return cost, which totaled around 20% of the cost of the bed. \n\nThis is obviously to deter you from returning it. \nHad I known this, I would've considered my options more carefully.",
      "created_at": "2023-11-30T02:35:58.000Z",
      "verified_buyer": true,
      "reviewer": "Alexander A.",
      "product_handle": "boutique-mattress-memory-foam",
      "product_title": "Boutique Mattress",
      "tags": [
        "back",
        "partner",
        "box",
        "value"
      ]
    },
    {
      "id": 674092580,
      "score": 2,
      "title": "100 Day Trial is risky and expensive",
      "content": "The mattress is fine but turned out to be not suitable for us. We contacted Mattress Crafters to arrange to return within the 100 day “trial period” only to be informed that the courier cost to return would be $350 (hence a refund of only $200). It means we feel stuck with a mattress that isn’t suitable but won’t be able to afford a different option if we return this one due to the exponential courier fee! It is interesting that they can ship for free but charge $350 for a return…?!",
      "created_at": "2025-01-28T20:16:55.000Z",
      "verified_buyer": false,
      "reviewer": "Max",
      "product_handle": "boutique-mattress-memory-foam",
      "product_title": "Boutique Mattress",
      "tags": [
        "box",
        "value"
      ]
    },
    {
      "id": 717887393,
      "score": 1,
      "title": "Could feel the springs",
      "content": "I could feel the springs. Gave mine away. Not recommended.",
      "created_at": "2025-06-13T18:15:18.000Z",
      "verified_buyer": true,
      "reviewer": "Christine G.",
      "product_handle": "boutique-mattress-memory-foam",
      "product_title": "Boutique Mattress",
      "tags": []
    },
    {
      "id": 680309490,
      "score": 1,
      "title": "delivery a complete joke",
      "content": "The delivery of two mattresses where a complete joke. They were delivered very early in the morning and left outside the property with no attempt to contact people at home, requiring a neighbour to spot them and contact us. Further they were both left leaning against a fence, bowing the metal due to their combined weight. \n\nThe mattress them self are awesome and highly recommended",
      "created_at": "2025-02-19T02:26:42.000Z",
      "verified_buyer": true,
      "reviewer": "Sarah C.",
      "product_handle": "boutique-mattress-memory-foam",
      "product_title": "Boutique Mattress",
      "tags": []
    },
    {
      "id": 709738168,
      "score": 4,
      "title": "Good quality mattress",
      "content": "We ordered the Grandeur Mattress for its good properties and value for money delivered at home. We were surprised to see how small it appears condensed in a box. After unfolding you get a pretty good looking mattress. \nOverall after first week of sleep found it of good quality, but possibly a bit more on the firm side of medium.",
      "created_at": "2025-05-16T23:39:15.000Z",
      "verified_buyer": true,
      "reviewer": "Georgios Z.",
      "product_handle": "grandeur",
      "product_title": "Grandeur Mattress",
      "tags": [
        "box",
        "value"
      ]
    },
    {
      "id": 870139623,
      "score": 5,
      "title": "Grandeur mattress",
      "content": "Sensational mattress and price, this Company is fantastic, Australian owned and get a big tick and thankyou from me.\nIf you have lower back, hip or shoulder problems, buy this mattress! It really is a beauty, we love it. My wife is 64kg, Im 94kg with lower back injuries. For the first time in years, I can have a good night sleep and feel good in the morning. Edge support is very good, dont feel like falling off, partner disturbance is minimal, body support is excellent, getting a good nights sleep score is excellent.",
      "created_at": "2026-07-15T22:05:13.000Z",
      "verified_buyer": true,
      "reviewer": "John L.",
      "product_handle": "grandeur",
      "product_title": "Grandeur Mattress",
      "tags": [
        "back",
        "hips",
        "partner",
        "value"
      ]
    },
    {
      "id": 854194650,
      "score": 5,
      "title": "Love this mattress! Great price,",
      "content": "Love this mattress! Great price, free and quick delivery and quality product.",
      "created_at": "2026-06-14T10:27:22.000Z",
      "verified_buyer": true,
      "reviewer": "Karen S.",
      "product_handle": "grandeur",
      "product_title": "Grandeur Mattress",
      "tags": [
        "value"
      ]
    },
    {
      "id": 831814510,
      "score": 5,
      "title": "Grandeur it is!",
      "content": "We love the Grandeur mattress - super comfy. My whole body feels supported, soft, yet firm, can't feel my partner moving around, and it looks very impressive. Thank you for this treat at an amazing price.",
      "created_at": "2026-04-20T10:22:02.000Z",
      "verified_buyer": true,
      "reviewer": "Fiona H.",
      "product_handle": "grandeur",
      "product_title": "Grandeur Mattress",
      "tags": [
        "partner",
        "value"
      ]
    },
    {
      "id": 692056328,
      "score": 5,
      "title": "Great buy, arrived next day",
      "content": "Great buy, arrived next day as mentioned😊😊",
      "created_at": "2025-03-25T09:09:42.000Z",
      "verified_buyer": true,
      "reviewer": "Sandipkumar P.",
      "product_handle": "grandeur",
      "product_title": "Grandeur Mattress",
      "tags": []
    },
    {
      "id": 689533529,
      "score": 5,
      "title": "great mattress",
      "content": "nice mattress",
      "created_at": "2025-03-16T12:00:59.000Z",
      "verified_buyer": true,
      "reviewer": "Albert F.",
      "product_handle": "grandeur",
      "product_title": "Grandeur Mattress",
      "tags": []
    },
    {
      "id": 590861576,
      "score": 5,
      "title": "Love it",
      "content": "Great experience, super fast shipping, amazing quality and great value for money. It’s love at first sight 11/10",
      "created_at": "2024-06-17T14:16:09.000Z",
      "verified_buyer": true,
      "reviewer": "Bill",
      "product_handle": "grandeur",
      "product_title": "Grandeur Mattress",
      "tags": [
        "value"
      ]
    },
    {
      "id": 498517582,
      "score": 5,
      "title": "Nice and easy!",
      "content": "Easy to order, fast delivery and very comfortable. Quick response to my queries. Thank you!",
      "created_at": "2023-09-06T10:13:01.000Z",
      "verified_buyer": true,
      "reviewer": "Kerri L.",
      "product_handle": "grandeur",
      "product_title": "Grandeur Mattress",
      "tags": []
    },
    {
      "id": 456256836,
      "score": 5,
      "title": "Great product great price easy service",
      "content": "Mattress so comfortable more than expected. Very fast service and easy order. Will highly recommend",
      "created_at": "2023-03-29T02:50:30.000Z",
      "verified_buyer": true,
      "reviewer": "Tanya t.",
      "product_handle": "grandeur",
      "product_title": "Grandeur Mattress",
      "tags": [
        "value"
      ]
    },
    {
      "id": 395749683,
      "score": 5,
      "title": "Great Mattress",
      "content": "Received quickly and very compact package. Opening was easy and immediately expanded into a lovely comfortable mattress. Quality is outstanding and first night sleep was solid waking refreshed. Very happy with purchase and can highly recommend.",
      "created_at": "2022-08-21T21:39:17.000Z",
      "verified_buyer": true,
      "reviewer": "Kevin P.",
      "product_handle": "grandeur",
      "product_title": "Grandeur Mattress",
      "tags": [
        "box"
      ]
    },
    {
      "id": 679756178,
      "score": 4,
      "title": "Good mattress",
      "content": "Not bad for its price.",
      "created_at": "2025-02-17T09:45:16.000Z",
      "verified_buyer": false,
      "reviewer": "Albert F.",
      "product_handle": "grandeur",
      "product_title": "Grandeur Mattress",
      "tags": [
        "value"
      ]
    },
    {
      "id": 347589836,
      "score": 4,
      "title": "Super comfortable bed with adequate",
      "content": "Super comfortable bed with adequate firmness.",
      "created_at": "2022-03-15T00:00:00.000Z",
      "verified_buyer": false,
      "reviewer": "Man S.",
      "product_handle": "grandeur",
      "product_title": "Grandeur Mattress",
      "tags": []
    },
    {
      "id": 723971220,
      "score": 3,
      "title": "Not the quality I expected",
      "content": "The mattress is somewhat disappointing. It is as hard as a rock to sleep on and very heavy to make. I gave up my old 20 yr old mattress for something more uncomfortable.",
      "created_at": "2025-07-01T16:21:44.000Z",
      "verified_buyer": true,
      "reviewer": "Terry P.",
      "product_handle": "grandeur",
      "product_title": "Grandeur Mattress",
      "tags": []
    },
    {
      "id": 885487919,
      "score": 5,
      "title": "Good mattress well built for",
      "content": "Good mattress well built for a fair price",
      "created_at": "2026-08-31T01:14:02.000Z",
      "verified_buyer": true,
      "reviewer": "Steve W.",
      "product_handle": "resort",
      "product_title": "Resort Mattress",
      "tags": [
        "value"
      ]
    },
    {
      "id": 328515023,
      "score": 5,
      "title": "Both mattresses i order are",
      "content": "Both mattresses i order are very comfortable and my children get a fantastic night sleep. Will definitely be buying again when need new ones.",
      "created_at": "2022-01-12T00:00:00.000Z",
      "verified_buyer": false,
      "reviewer": "Angela",
      "product_handle": "resort",
      "product_title": "Resort Mattress",
      "tags": [
        "kids"
      ]
    },
    {
      "id": 872463908,
      "score": 5,
      "title": "Great experience",
      "content": "Great experience",
      "created_at": "2026-07-23T00:03:55.000Z",
      "verified_buyer": true,
      "reviewer": "Glenn W.",
      "product_handle": "retreat",
      "product_title": "Retreat Mattress",
      "tags": []
    },
    {
      "id": 529646301,
      "score": 5,
      "title": "The twist is upside down,",
      "content": "The twist is upside down, not big but you notice when you open the mattress, so it unrolls upside down.",
      "created_at": "2023-12-11T09:01:33.000Z",
      "verified_buyer": true,
      "reviewer": "Thomas C.",
      "product_handle": "retreat",
      "product_title": "Retreat Mattress",
      "tags": []
    },
    {
      "id": 368015139,
      "score": 5,
      "title": "King size mattress",
      "content": "easy to move it upstairs and install. Very comfortable to sleep on.",
      "created_at": "2022-05-18T12:30:21.000Z",
      "verified_buyer": true,
      "reviewer": "Tristan F.",
      "product_handle": "retreat",
      "product_title": "Retreat Mattress",
      "tags": []
    },
    {
      "id": 314189403,
      "score": 5,
      "title": "good quality excellent service",
      "content": "good quality excellent service",
      "created_at": "2021-11-19T00:00:00.000Z",
      "verified_buyer": false,
      "reviewer": "sstrickfuss12013",
      "product_handle": "retreat",
      "product_title": "Retreat Mattress",
      "tags": []
    },
    {
      "id": 310297225,
      "score": 5,
      "title": "excellent and on time !",
      "content": "excellent and on time !",
      "created_at": "2021-10-21T00:00:00.000Z",
      "verified_buyer": false,
      "reviewer": "1901rees",
      "product_handle": "retreat",
      "product_title": "Retreat Mattress",
      "tags": []
    },
    {
      "id": 288643716,
      "score": 5,
      "title": "excellent mattress...!",
      "content": "excellent mattress...!",
      "created_at": "2021-08-27T00:00:00.000Z",
      "verified_buyer": false,
      "reviewer": "bay_link",
      "product_handle": "retreat",
      "product_title": "Retreat Mattress",
      "tags": []
    },
    {
      "id": 456257248,
      "score": 4,
      "title": "Good mattress for price",
      "content": "Purchased for a short term rental, so far so good. Very good price and easy service",
      "created_at": "2023-03-29T02:51:05.000Z",
      "verified_buyer": true,
      "reviewer": "Tanya t.",
      "product_handle": "retreat",
      "product_title": "Retreat Mattress",
      "tags": [
        "value"
      ]
    },
    {
      "id": 288592315,
      "score": 5,
      "title": "all good",
      "content": "all good",
      "created_at": "2021-08-25T00:00:00.000Z",
      "verified_buyer": false,
      "reviewer": "wheels4you2010",
      "product_handle": "superior",
      "product_title": "Superior Mattress",
      "tags": []
    },
    {
      "id": 288490206,
      "score": 5,
      "title": "Very happy with quality, comfort,",
      "content": "Very happy with quality, comfort, price and delivery",
      "created_at": "2021-07-13T00:00:00.000Z",
      "verified_buyer": false,
      "reviewer": "Kim",
      "product_handle": "superior",
      "product_title": "Superior Mattress",
      "tags": [
        "value"
      ]
    },
    {
      "id": 288501406,
      "score": 5,
      "title": "A little firmer than expected",
      "content": "A little firmer than expected but was labelled as medium firm and is just perfect as sometimes mediums get too soft. No more rolling together as the pocket springs do a great job. Fast, easy, great service. We need to get a few more for the house. Highly recommended product!",
      "created_at": "2021-06-01T00:00:00.000Z",
      "verified_buyer": false,
      "reviewer": "The D.",
      "product_handle": "superior",
      "product_title": "Superior Mattress",
      "tags": [
        "partner"
      ]
    },
    {
      "id": 288592332,
      "score": 5,
      "title": "Awesome mattress. Great to deal",
      "content": "Awesome mattress. Great to deal with. Highly recommended seller.",
      "created_at": "2021-05-06T00:00:00.000Z",
      "verified_buyer": false,
      "reviewer": "qpi98",
      "product_handle": "superior",
      "product_title": "Superior Mattress",
      "tags": []
    },
    {
      "id": 288592328,
      "score": 5,
      "title": "Excellent with great product with",
      "content": "Excellent with great product with fast delivery",
      "created_at": "2021-05-05T00:00:00.000Z",
      "verified_buyer": false,
      "reviewer": "cammanspl",
      "product_handle": "superior",
      "product_title": "Superior Mattress",
      "tags": []
    },
    {
      "id": 288592323,
      "score": 5,
      "title": "Excellent mattress. Great seller. Highly",
      "content": "Excellent mattress. Great seller. Highly recommended.",
      "created_at": "2021-04-14T00:00:00.000Z",
      "verified_buyer": false,
      "reviewer": "qpi98",
      "product_handle": "superior",
      "product_title": "Superior Mattress",
      "tags": []
    },
    {
      "id": 288592327,
      "score": 5,
      "title": "I�m very happy with my",
      "content": "I�m very happy with my mattress, it came out of the box and quickly regained its shape, it is very comfortable and soft, but supportive, I sleep so soundly on this mattress, no more sore hips or shoulders, highly recommended.",
      "created_at": "2021-04-10T00:00:00.000Z",
      "verified_buyer": false,
      "reviewer": "pavit.su",
      "product_handle": "superior",
      "product_title": "Superior Mattress",
      "tags": [
        "hips"
      ]
    },
    {
      "id": 288492211,
      "score": 4,
      "title": "Quick delivery and the mattress",
      "content": "Quick delivery and the mattress is so comfortable. Good materials and provide better sleep.",
      "created_at": "2021-04-29T00:00:00.000Z",
      "verified_buyer": false,
      "reviewer": "MB",
      "product_handle": "superior",
      "product_title": "Superior Mattress",
      "tags": []
    },
    {
      "id": 783867581,
      "score": 5,
      "title": "No regrets!",
      "content": "My neck and back have never felt better after a nights sleep. Got the firm and feels firm in support yet soft on top without sinking.\n\nCame in a box which i was plesantly surprised by.",
      "created_at": "2025-11-21T02:10:36.000Z",
      "verified_buyer": true,
      "reviewer": "Josh",
      "product_handle": "chiro-luxe",
      "product_title": "Therapedic Chiro Luxe Mattress",
      "tags": [
        "box"
      ]
    },
    {
      "id": 882002781,
      "score": 5,
      "title": "Extremely Happy",
      "content": "This mattress is fantastic. I wake up refreshed and without the aches and pains I previously had. I did a lot of research before committing to buy a mattress and was wary of buying a mattress on line but the experience has been fantastic. The mattress has all the features I was looking for. Delivery was very quick and the price was significantly lower than actual retailers. I could not be happier. Thank you",
      "created_at": "2026-08-17T03:12:31.000Z",
      "verified_buyer": true,
      "reviewer": "Leone C.",
      "product_handle": "elevate-essential-mattress",
      "product_title": "Therapedic Elevate Essential Mattress",
      "tags": [
        "value"
      ]
    },
    {
      "id": 882950492,
      "score": 5,
      "title": "Off the charts comfort",
      "content": "Perfect on every way - especially paired with a high loft mattress topper. You’ll think you’re sleeping on a five star hotel mattress every night of the week. Efficient delivery and a company which finally does what it says it’ll do in the ads. Highly recommended.",
      "created_at": "2026-08-19T04:48:48.000Z",
      "verified_buyer": true,
      "reviewer": "Gabi M.",
      "product_handle": "exquisite-signature-mattress",
      "product_title": "Therapedic Exquisite Signature Mattress",
      "tags": []
    }
  ]
};
